import _regeneratorRuntime from "D:\\a\\1\\s\\Agrithmics.Tips.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "D:\\a\\1\\s\\Agrithmics.Tips.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "D:\\a\\1\\s\\Agrithmics.Tips.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\a\\1\\s\\Agrithmics.Tips.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\Agrithmics.Tips.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
var module,
    common = (function (module, exports) {
  var TYPED_OK = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

  function _has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  exports.assign = function (obj) {
    for (var sources = Array.prototype.slice.call(arguments, 1); sources.length;) {
      var source = sources.shift();

      if (source) {
        if ("object" != typeof source) throw new TypeError(source + "must be non-object");

        for (var p in source) {
          _has(source, p) && (obj[p] = source[p]);
        }
      }
    }

    return obj;
  }, exports.shrinkBuf = function (buf, size) {
    return buf.length === size ? buf : buf.subarray ? buf.subarray(0, size) : (buf.length = size, buf);
  };
  var fnTyped = {
    arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
      if (src.subarray && dest.subarray) dest.set(src.subarray(src_offs, src_offs + len), dest_offs);else for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src[src_offs + i];
      }
    },
    flattenChunks: function flattenChunks(chunks) {
      var i, l, len, pos, chunk, result;

      for (len = 0, i = 0, l = chunks.length; i < l; i++) {
        len += chunks[i].length;
      }

      for (result = new Uint8Array(len), pos = 0, i = 0, l = chunks.length; i < l; i++) {
        chunk = chunks[i], result.set(chunk, pos), pos += chunk.length;
      }

      return result;
    }
  },
      fnUntyped = {
    arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
      for (var i = 0; i < len; i++) {
        dest[dest_offs + i] = src[src_offs + i];
      }
    },
    flattenChunks: function flattenChunks(chunks) {
      return [].concat.apply([], chunks);
    }
  };
  exports.setTyped = function (on) {
    on ? (exports.Buf8 = Uint8Array, exports.Buf16 = Uint16Array, exports.Buf32 = Int32Array, exports.assign(exports, fnTyped)) : (exports.Buf8 = Array, exports.Buf16 = Array, exports.Buf32 = Array, exports.assign(exports, fnUntyped));
  }, exports.setTyped(TYPED_OK);
}(module = {
  exports: {}
}, module.exports), module.exports),
    Z_FIXED = (common.assign, common.shrinkBuf, common.setTyped, common.Buf8, common.Buf16, common.Buf32, 4),
    Z_BINARY = 0,
    Z_TEXT = 1,
    Z_UNKNOWN = 2;

function zero(buf) {
  for (var len = buf.length; --len >= 0;) {
    buf[len] = 0;
  }
}

var STORED_BLOCK = 0,
    STATIC_TREES = 1,
    DYN_TREES = 2,
    LENGTH_CODES = 29,
    LITERALS = 256,
    L_CODES = LITERALS + 1 + LENGTH_CODES,
    D_CODES = 30,
    BL_CODES = 19,
    HEAP_SIZE = 2 * L_CODES + 1,
    MAX_BITS = 15,
    Buf_size = 16,
    MAX_BL_BITS = 7,
    END_BLOCK = 256,
    REP_3_6 = 16,
    REPZ_3_10 = 17,
    REPZ_11_138 = 18,
    extra_lbits = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
    extra_dbits = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
    extra_blbits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
    bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
    static_ltree = new Array(2 * (L_CODES + 2));
zero(static_ltree);
var static_dtree = new Array(2 * D_CODES);
zero(static_dtree);

var _dist_code = new Array(512);

zero(_dist_code);

var _length_code = new Array(256);

zero(_length_code);
var base_length = new Array(LENGTH_CODES);
zero(base_length);
var static_l_desc,
    static_d_desc,
    static_bl_desc,
    base_dist = new Array(D_CODES);

function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
  this.static_tree = static_tree, this.extra_bits = extra_bits, this.extra_base = extra_base, this.elems = elems, this.max_length = max_length, this.has_stree = static_tree && static_tree.length;
}

function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree, this.max_code = 0, this.stat_desc = stat_desc;
}

function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}

function put_short(s, w) {
  s.pending_buf[s.pending++] = 255 & w, s.pending_buf[s.pending++] = w >>> 8 & 255;
}

function send_bits(s, value, length) {
  s.bi_valid > Buf_size - length ? (s.bi_buf |= value << s.bi_valid & 65535, put_short(s, s.bi_buf), s.bi_buf = value >> Buf_size - s.bi_valid, s.bi_valid += length - Buf_size) : (s.bi_buf |= value << s.bi_valid & 65535, s.bi_valid += length);
}

function send_code(s, c, tree) {
  send_bits(s, tree[2 * c], tree[2 * c + 1]);
}

function bi_reverse(code, len) {
  var res = 0;

  do {
    res |= 1 & code, code >>>= 1, res <<= 1;
  } while (--len > 0);

  return res >>> 1;
}

function gen_codes(tree, max_code, bl_count) {
  var bits,
      n,
      next_code = new Array(MAX_BITS + 1),
      code = 0;

  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = code + bl_count[bits - 1] << 1;
  }

  for (n = 0; n <= max_code; n++) {
    var len = tree[2 * n + 1];
    0 !== len && (tree[2 * n] = bi_reverse(next_code[len]++, len));
  }
}

function init_block(s) {
  var n;

  for (n = 0; n < L_CODES; n++) {
    s.dyn_ltree[2 * n] = 0;
  }

  for (n = 0; n < D_CODES; n++) {
    s.dyn_dtree[2 * n] = 0;
  }

  for (n = 0; n < BL_CODES; n++) {
    s.bl_tree[2 * n] = 0;
  }

  s.dyn_ltree[2 * END_BLOCK] = 1, s.opt_len = s.static_len = 0, s.last_lit = s.matches = 0;
}

function bi_windup(s) {
  s.bi_valid > 8 ? put_short(s, s.bi_buf) : s.bi_valid > 0 && (s.pending_buf[s.pending++] = s.bi_buf), s.bi_buf = 0, s.bi_valid = 0;
}

function smaller(tree, n, m, depth) {
  var _n2 = 2 * n,
      _m2 = 2 * m;

  return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}

function pqdownheap(s, tree, k) {
  for (var v = s.heap[k], j = k << 1; j <= s.heap_len && (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth) && j++, !smaller(tree, v, s.heap[j], s.depth));) {
    s.heap[k] = s.heap[j], k = j, j <<= 1;
  }

  s.heap[k] = v;
}

function compress_block(s, ltree, dtree) {
  var dist,
      lc,
      code,
      extra,
      lx = 0;
  if (0 !== s.last_lit) do {
    dist = s.pending_buf[s.d_buf + 2 * lx] << 8 | s.pending_buf[s.d_buf + 2 * lx + 1], lc = s.pending_buf[s.l_buf + lx], lx++, 0 === dist ? send_code(s, lc, ltree) : (send_code(s, (code = _length_code[lc]) + LITERALS + 1, ltree), 0 !== (extra = extra_lbits[code]) && send_bits(s, lc -= base_length[code], extra), send_code(s, code = d_code(--dist), dtree), 0 !== (extra = extra_dbits[code]) && send_bits(s, dist -= base_dist[code], extra));
  } while (lx < s.last_lit);
  send_code(s, END_BLOCK, ltree);
}

function build_tree(s, desc) {
  var n,
      m,
      node,
      tree = desc.dyn_tree,
      stree = desc.stat_desc.static_tree,
      has_stree = desc.stat_desc.has_stree,
      elems = desc.stat_desc.elems,
      max_code = -1;

  for (s.heap_len = 0, s.heap_max = HEAP_SIZE, n = 0; n < elems; n++) {
    0 !== tree[2 * n] ? (s.heap[++s.heap_len] = max_code = n, s.depth[n] = 0) : tree[2 * n + 1] = 0;
  }

  for (; s.heap_len < 2;) {
    tree[2 * (node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0)] = 1, s.depth[node] = 0, s.opt_len--, has_stree && (s.static_len -= stree[2 * node + 1]);
  }

  for (desc.max_code = max_code, n = s.heap_len >> 1; n >= 1; n--) {
    pqdownheap(s, tree, n);
  }

  node = elems;

  do {
    n = s.heap[1], s.heap[1] = s.heap[s.heap_len--], pqdownheap(s, tree, 1), m = s.heap[1], s.heap[--s.heap_max] = n, s.heap[--s.heap_max] = m, tree[2 * node] = tree[2 * n] + tree[2 * m], s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1, tree[2 * n + 1] = tree[2 * m + 1] = node, s.heap[1] = node++, pqdownheap(s, tree, 1);
  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1], function (s, desc) {
    var h,
        n,
        m,
        bits,
        xbits,
        f,
        tree = desc.dyn_tree,
        max_code = desc.max_code,
        stree = desc.stat_desc.static_tree,
        has_stree = desc.stat_desc.has_stree,
        extra = desc.stat_desc.extra_bits,
        base = desc.stat_desc.extra_base,
        max_length = desc.stat_desc.max_length,
        overflow = 0;

    for (bits = 0; bits <= MAX_BITS; bits++) {
      s.bl_count[bits] = 0;
    }

    for (tree[2 * s.heap[s.heap_max] + 1] = 0, h = s.heap_max + 1; h < HEAP_SIZE; h++) {
      (bits = tree[2 * tree[2 * (n = s.heap[h]) + 1] + 1] + 1) > max_length && (bits = max_length, overflow++), tree[2 * n + 1] = bits, n > max_code || (s.bl_count[bits]++, xbits = 0, n >= base && (xbits = extra[n - base]), f = tree[2 * n], s.opt_len += f * (bits + xbits), has_stree && (s.static_len += f * (stree[2 * n + 1] + xbits)));
    }

    if (0 !== overflow) {
      do {
        for (bits = max_length - 1; 0 === s.bl_count[bits];) {
          bits--;
        }

        s.bl_count[bits]--, s.bl_count[bits + 1] += 2, s.bl_count[max_length]--, overflow -= 2;
      } while (overflow > 0);

      for (bits = max_length; 0 !== bits; bits--) {
        for (n = s.bl_count[bits]; 0 !== n;) {
          (m = s.heap[--h]) > max_code || (tree[2 * m + 1] !== bits && (s.opt_len += (bits - tree[2 * m + 1]) * tree[2 * m], tree[2 * m + 1] = bits), n--);
        }
      }
    }
  }(s, desc), gen_codes(tree, max_code, s.bl_count);
}

function scan_tree(s, tree, max_code) {
  var n,
      curlen,
      prevlen = -1,
      nextlen = tree[1],
      count = 0,
      max_count = 7,
      min_count = 4;

  for (0 === nextlen && (max_count = 138, min_count = 3), tree[2 * (max_code + 1) + 1] = 65535, n = 0; n <= max_code; n++) {
    curlen = nextlen, nextlen = tree[2 * (n + 1) + 1], ++count < max_count && curlen === nextlen || (count < min_count ? s.bl_tree[2 * curlen] += count : 0 !== curlen ? (curlen !== prevlen && s.bl_tree[2 * curlen]++, s.bl_tree[2 * REP_3_6]++) : count <= 10 ? s.bl_tree[2 * REPZ_3_10]++ : s.bl_tree[2 * REPZ_11_138]++, count = 0, prevlen = curlen, 0 === nextlen ? (max_count = 138, min_count = 3) : curlen === nextlen ? (max_count = 6, min_count = 3) : (max_count = 7, min_count = 4));
  }
}

function send_tree(s, tree, max_code) {
  var n,
      curlen,
      prevlen = -1,
      nextlen = tree[1],
      count = 0,
      max_count = 7,
      min_count = 4;

  for (0 === nextlen && (max_count = 138, min_count = 3), n = 0; n <= max_code; n++) {
    if (curlen = nextlen, nextlen = tree[2 * (n + 1) + 1], !(++count < max_count && curlen === nextlen)) {
      if (count < min_count) do {
        send_code(s, curlen, s.bl_tree);
      } while (0 != --count);else 0 !== curlen ? (curlen !== prevlen && (send_code(s, curlen, s.bl_tree), count--), send_code(s, REP_3_6, s.bl_tree), send_bits(s, count - 3, 2)) : count <= 10 ? (send_code(s, REPZ_3_10, s.bl_tree), send_bits(s, count - 3, 3)) : (send_code(s, REPZ_11_138, s.bl_tree), send_bits(s, count - 11, 7));
      count = 0, prevlen = curlen, 0 === nextlen ? (max_count = 138, min_count = 3) : curlen === nextlen ? (max_count = 6, min_count = 3) : (max_count = 7, min_count = 4);
    }
  }
}

zero(base_dist);
var static_init_done = !1;

function _tr_stored_block(s, buf, stored_len, last) {
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3), function (s, buf, len, header) {
    bi_windup(s), header && (put_short(s, len), put_short(s, ~len)), common.arraySet(s.pending_buf, s.window, buf, len, s.pending), s.pending += len;
  }(s, buf, stored_len, !0);
}

var trees = {
  _tr_init: function _tr_init(s) {
    static_init_done || (!function () {
      var n,
          bits,
          length,
          code,
          dist,
          bl_count = new Array(MAX_BITS + 1);

      for (length = 0, code = 0; code < LENGTH_CODES - 1; code++) {
        for (base_length[code] = length, n = 0; n < 1 << extra_lbits[code]; n++) {
          _length_code[length++] = code;
        }
      }

      for (_length_code[length - 1] = code, dist = 0, code = 0; code < 16; code++) {
        for (base_dist[code] = dist, n = 0; n < 1 << extra_dbits[code]; n++) {
          _dist_code[dist++] = code;
        }
      }

      for (dist >>= 7; code < D_CODES; code++) {
        for (base_dist[code] = dist << 7, n = 0; n < 1 << extra_dbits[code] - 7; n++) {
          _dist_code[256 + dist++] = code;
        }
      }

      for (bits = 0; bits <= MAX_BITS; bits++) {
        bl_count[bits] = 0;
      }

      for (n = 0; n <= 143;) {
        static_ltree[2 * n + 1] = 8, n++, bl_count[8]++;
      }

      for (; n <= 255;) {
        static_ltree[2 * n + 1] = 9, n++, bl_count[9]++;
      }

      for (; n <= 279;) {
        static_ltree[2 * n + 1] = 7, n++, bl_count[7]++;
      }

      for (; n <= 287;) {
        static_ltree[2 * n + 1] = 8, n++, bl_count[8]++;
      }

      for (gen_codes(static_ltree, L_CODES + 1, bl_count), n = 0; n < D_CODES; n++) {
        static_dtree[2 * n + 1] = 5, static_dtree[2 * n] = bi_reverse(n, 5);
      }

      static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
    }(), static_init_done = !0), s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc), s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc), s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc), s.bi_buf = 0, s.bi_valid = 0, init_block(s);
  },
  _tr_stored_block: _tr_stored_block,
  _tr_flush_block: function _tr_flush_block(s, buf, stored_len, last) {
    var opt_lenb,
        static_lenb,
        max_blindex = 0;
    s.level > 0 ? (s.strm.data_type === Z_UNKNOWN && (s.strm.data_type = function (s) {
      var n,
          black_mask = 4093624447;

      for (n = 0; n <= 31; n++, black_mask >>>= 1) {
        if (1 & black_mask && 0 !== s.dyn_ltree[2 * n]) return Z_BINARY;
      }

      if (0 !== s.dyn_ltree[18] || 0 !== s.dyn_ltree[20] || 0 !== s.dyn_ltree[26]) return Z_TEXT;

      for (n = 32; n < LITERALS; n++) {
        if (0 !== s.dyn_ltree[2 * n]) return Z_TEXT;
      }

      return Z_BINARY;
    }(s)), build_tree(s, s.l_desc), build_tree(s, s.d_desc), max_blindex = function (s) {
      var max_blindex;

      for (scan_tree(s, s.dyn_ltree, s.l_desc.max_code), scan_tree(s, s.dyn_dtree, s.d_desc.max_code), build_tree(s, s.bl_desc), max_blindex = BL_CODES - 1; max_blindex >= 3 && 0 === s.bl_tree[2 * bl_order[max_blindex] + 1]; max_blindex--) {
        ;
      }

      return s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4, max_blindex;
    }(s), opt_lenb = s.opt_len + 3 + 7 >>> 3, (static_lenb = s.static_len + 3 + 7 >>> 3) <= opt_lenb && (opt_lenb = static_lenb)) : opt_lenb = static_lenb = stored_len + 5, stored_len + 4 <= opt_lenb && -1 !== buf ? _tr_stored_block(s, buf, stored_len, last) : s.strategy === Z_FIXED || static_lenb === opt_lenb ? (send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3), compress_block(s, static_ltree, static_dtree)) : (send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3), function (s, lcodes, dcodes, blcodes) {
      var rank;

      for (send_bits(s, lcodes - 257, 5), send_bits(s, dcodes - 1, 5), send_bits(s, blcodes - 4, 4), rank = 0; rank < blcodes; rank++) {
        send_bits(s, s.bl_tree[2 * bl_order[rank] + 1], 3);
      }

      send_tree(s, s.dyn_ltree, lcodes - 1), send_tree(s, s.dyn_dtree, dcodes - 1);
    }(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1), compress_block(s, s.dyn_ltree, s.dyn_dtree)), init_block(s), last && bi_windup(s);
  },
  _tr_tally: function _tr_tally(s, dist, lc) {
    return s.pending_buf[s.d_buf + 2 * s.last_lit] = dist >>> 8 & 255, s.pending_buf[s.d_buf + 2 * s.last_lit + 1] = 255 & dist, s.pending_buf[s.l_buf + s.last_lit] = 255 & lc, s.last_lit++, 0 === dist ? s.dyn_ltree[2 * lc]++ : (s.matches++, dist--, s.dyn_ltree[2 * (_length_code[lc] + LITERALS + 1)]++, s.dyn_dtree[2 * d_code(dist)]++), s.last_lit === s.lit_bufsize - 1;
  },
  _tr_align: function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3), send_code(s, END_BLOCK, static_ltree), function (s) {
      16 === s.bi_valid ? (put_short(s, s.bi_buf), s.bi_buf = 0, s.bi_valid = 0) : s.bi_valid >= 8 && (s.pending_buf[s.pending++] = 255 & s.bi_buf, s.bi_buf >>= 8, s.bi_valid -= 8);
    }(s);
  }
};

var adler32_1 = function adler32_1(adler, buf, len, pos) {
  for (var s1 = 65535 & adler | 0, s2 = adler >>> 16 & 65535 | 0, n = 0; 0 !== len;) {
    len -= n = len > 2e3 ? 2e3 : len;

    do {
      s2 = s2 + (s1 = s1 + buf[pos++] | 0) | 0;
    } while (--n);

    s1 %= 65521, s2 %= 65521;
  }

  return s1 | s2 << 16 | 0;
};

var crcTable = function () {
  for (var c, table = [], n = 0; n < 256; n++) {
    c = n;

    for (var k = 0; k < 8; k++) {
      c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
    }

    table[n] = c;
  }

  return table;
}();

var configuration_table,
    crc32_1 = function crc32_1(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;
  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = crc >>> 8 ^ t[255 & (crc ^ buf[i])];
  }

  return -1 ^ crc;
},
    messages = {
  2: "need dictionary",
  1: "stream end",
  0: "",
  "-1": "file error",
  "-2": "stream error",
  "-3": "data error",
  "-4": "insufficient memory",
  "-5": "buffer error",
  "-6": "incompatible version"
},
    Z_NO_FLUSH = 0,
    Z_PARTIAL_FLUSH = 1,
    Z_FULL_FLUSH = 3,
    Z_FINISH = 4,
    Z_BLOCK = 5,
    Z_OK = 0,
    Z_STREAM_END = 1,
    Z_STREAM_ERROR = -2,
    Z_DATA_ERROR = -3,
    Z_BUF_ERROR = -5,
    Z_DEFAULT_COMPRESSION = -1,
    Z_FILTERED = 1,
    Z_HUFFMAN_ONLY = 2,
    Z_RLE = 3,
    Z_FIXED$1 = 4,
    Z_DEFAULT_STRATEGY = 0,
    Z_UNKNOWN$1 = 2,
    Z_DEFLATED = 8,
    MAX_MEM_LEVEL = 9,
    MAX_WBITS = 15,
    DEF_MEM_LEVEL = 8,
    L_CODES$1 = 286,
    D_CODES$1 = 30,
    BL_CODES$1 = 19,
    HEAP_SIZE$1 = 2 * L_CODES$1 + 1,
    MAX_BITS$1 = 15,
    MIN_MATCH$1 = 3,
    MAX_MATCH$1 = 258,
    MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1,
    PRESET_DICT = 32,
    INIT_STATE = 42,
    EXTRA_STATE = 69,
    NAME_STATE = 73,
    COMMENT_STATE = 91,
    HCRC_STATE = 103,
    BUSY_STATE = 113,
    FINISH_STATE = 666,
    BS_NEED_MORE = 1,
    BS_BLOCK_DONE = 2,
    BS_FINISH_STARTED = 3,
    BS_FINISH_DONE = 4,
    OS_CODE = 3;

function err(strm, errorCode) {
  return strm.msg = messages[errorCode], errorCode;
}

function rank(f) {
  return (f << 1) - (f > 4 ? 9 : 0);
}

function zero$1(buf) {
  for (var len = buf.length; --len >= 0;) {
    buf[len] = 0;
  }
}

function flush_pending(strm) {
  var s = strm.state,
      len = s.pending;
  len > strm.avail_out && (len = strm.avail_out), 0 !== len && (common.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out), strm.next_out += len, s.pending_out += len, strm.total_out += len, strm.avail_out -= len, s.pending -= len, 0 === s.pending && (s.pending_out = 0));
}

function flush_block_only(s, last) {
  trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last), s.block_start = s.strstart, flush_pending(s.strm);
}

function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}

function putShortMSB(s, b) {
  s.pending_buf[s.pending++] = b >>> 8 & 255, s.pending_buf[s.pending++] = 255 & b;
}

function longest_match(s, cur_match) {
  var match,
      len,
      chain_length = s.max_chain_length,
      scan = s.strstart,
      best_len = s.prev_length,
      nice_match = s.nice_match,
      limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0,
      _win = s.window,
      wmask = s.w_mask,
      prev = s.prev,
      strend = s.strstart + MAX_MATCH$1,
      scan_end1 = _win[scan + best_len - 1],
      scan_end = _win[scan + best_len];
  s.prev_length >= s.good_match && (chain_length >>= 2), nice_match > s.lookahead && (nice_match = s.lookahead);

  do {
    if (_win[(match = cur_match) + best_len] === scan_end && _win[match + best_len - 1] === scan_end1 && _win[match] === _win[scan] && _win[++match] === _win[scan + 1]) {
      scan += 2, match++;

      do {} while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);

      if (len = MAX_MATCH$1 - (strend - scan), scan = strend - MAX_MATCH$1, len > best_len) {
        if (s.match_start = cur_match, best_len = len, len >= nice_match) break;
        scan_end1 = _win[scan + best_len - 1], scan_end = _win[scan + best_len];
      }
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && 0 != --chain_length);

  return best_len <= s.lookahead ? best_len : s.lookahead;
}

function fill_window(s) {
  var p,
      n,
      m,
      more,
      str,
      strm,
      buf,
      start,
      size,
      len,
      _w_size = s.w_size;

  do {
    if (more = s.window_size - s.lookahead - s.strstart, s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
      common.arraySet(s.window, s.window, _w_size, _w_size, 0), s.match_start -= _w_size, s.strstart -= _w_size, s.block_start -= _w_size, p = n = s.hash_size;

      do {
        m = s.head[--p], s.head[p] = m >= _w_size ? m - _w_size : 0;
      } while (--n);

      p = n = _w_size;

      do {
        m = s.prev[--p], s.prev[p] = m >= _w_size ? m - _w_size : 0;
      } while (--n);

      more += _w_size;
    }

    if (0 === s.strm.avail_in) break;
    if (strm = s.strm, buf = s.window, start = s.strstart + s.lookahead, size = more, len = void 0, (len = strm.avail_in) > size && (len = size), n = 0 === len ? 0 : (strm.avail_in -= len, common.arraySet(buf, strm.input, strm.next_in, len, start), 1 === strm.state.wrap ? strm.adler = adler32_1(strm.adler, buf, len, start) : 2 === strm.state.wrap && (strm.adler = crc32_1(strm.adler, buf, len, start)), strm.next_in += len, strm.total_in += len, len), s.lookahead += n, s.lookahead + s.insert >= MIN_MATCH$1) for (str = s.strstart - s.insert, s.ins_h = s.window[str], s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask; s.insert && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH$1 - 1]) & s.hash_mask, s.prev[str & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = str, str++, s.insert--, !(s.lookahead + s.insert < MIN_MATCH$1));) {
      ;
    }
  } while (s.lookahead < MIN_LOOKAHEAD && 0 !== s.strm.avail_in);
}

function deflate_fast(s, flush) {
  for (var hash_head, bflush;;) {
    if (s.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(s), s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
      if (0 === s.lookahead) break;
    }

    if (hash_head = 0, s.lookahead >= MIN_MATCH$1 && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask, hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart), 0 !== hash_head && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD && (s.match_length = longest_match(s, hash_head)), s.match_length >= MIN_MATCH$1) {
      if (bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1), s.lookahead -= s.match_length, s.match_length <= s.max_lazy_match && s.lookahead >= MIN_MATCH$1) {
        s.match_length--;

        do {
          s.strstart++, s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask, hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart;
        } while (0 != --s.match_length);

        s.strstart++;
      } else s.strstart += s.match_length, s.match_length = 0, s.ins_h = s.window[s.strstart], s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
    } else bflush = trees._tr_tally(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++;
    if (bflush && (flush_block_only(s, !1), 0 === s.strm.avail_out)) return BS_NEED_MORE;
  }

  return s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1, flush === Z_FINISH ? (flush_block_only(s, !0), 0 === s.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : s.last_lit && (flush_block_only(s, !1), 0 === s.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
}

function deflate_slow(s, flush) {
  for (var hash_head, bflush, max_insert;;) {
    if (s.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(s), s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
      if (0 === s.lookahead) break;
    }

    if (hash_head = 0, s.lookahead >= MIN_MATCH$1 && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask, hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart), s.prev_length = s.match_length, s.prev_match = s.match_start, s.match_length = MIN_MATCH$1 - 1, 0 !== hash_head && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD && (s.match_length = longest_match(s, hash_head), s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096) && (s.match_length = MIN_MATCH$1 - 1)), s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH$1, bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1), s.lookahead -= s.prev_length - 1, s.prev_length -= 2;

      do {
        ++s.strstart <= max_insert && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH$1 - 1]) & s.hash_mask, hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart);
      } while (0 != --s.prev_length);

      if (s.match_available = 0, s.match_length = MIN_MATCH$1 - 1, s.strstart++, bflush && (flush_block_only(s, !1), 0 === s.strm.avail_out)) return BS_NEED_MORE;
    } else if (s.match_available) {
      if ((bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1])) && flush_block_only(s, !1), s.strstart++, s.lookahead--, 0 === s.strm.avail_out) return BS_NEED_MORE;
    } else s.match_available = 1, s.strstart++, s.lookahead--;
  }

  return s.match_available && (bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]), s.match_available = 0), s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1, flush === Z_FINISH ? (flush_block_only(s, !0), 0 === s.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : s.last_lit && (flush_block_only(s, !1), 0 === s.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
}

function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length, this.max_lazy = max_lazy, this.nice_length = nice_length, this.max_chain = max_chain, this.func = func;
}

function DeflateState() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new common.Buf16(2 * HEAP_SIZE$1), this.dyn_dtree = new common.Buf16(2 * (2 * D_CODES$1 + 1)), this.bl_tree = new common.Buf16(2 * (2 * BL_CODES$1 + 1)), zero$1(this.dyn_ltree), zero$1(this.dyn_dtree), zero$1(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new common.Buf16(MAX_BITS$1 + 1), this.heap = new common.Buf16(2 * L_CODES$1 + 1), zero$1(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new common.Buf16(2 * L_CODES$1 + 1), zero$1(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}

function deflateResetKeep(strm) {
  var s;
  return strm && strm.state ? (strm.total_in = strm.total_out = 0, strm.data_type = Z_UNKNOWN$1, (s = strm.state).pending = 0, s.pending_out = 0, s.wrap < 0 && (s.wrap = -s.wrap), s.status = s.wrap ? INIT_STATE : BUSY_STATE, strm.adler = 2 === s.wrap ? 0 : 1, s.last_flush = Z_NO_FLUSH, trees._tr_init(s), Z_OK) : err(strm, Z_STREAM_ERROR);
}

function deflateReset(strm) {
  var s,
      ret = deflateResetKeep(strm);
  return ret === Z_OK && ((s = strm.state).window_size = 2 * s.w_size, zero$1(s.head), s.max_lazy_match = configuration_table[s.level].max_lazy, s.good_match = configuration_table[s.level].good_length, s.nice_match = configuration_table[s.level].nice_length, s.max_chain_length = configuration_table[s.level].max_chain, s.strstart = 0, s.block_start = 0, s.lookahead = 0, s.insert = 0, s.match_length = s.prev_length = MIN_MATCH$1 - 1, s.match_available = 0, s.ins_h = 0), ret;
}

function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) return Z_STREAM_ERROR;
  var wrap = 1;
  if (level === Z_DEFAULT_COMPRESSION && (level = 6), windowBits < 0 ? (wrap = 0, windowBits = -windowBits) : windowBits > 15 && (wrap = 2, windowBits -= 16), memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED$1) return err(strm, Z_STREAM_ERROR);
  8 === windowBits && (windowBits = 9);
  var s = new DeflateState();
  return strm.state = s, s.strm = strm, s.wrap = wrap, s.gzhead = null, s.w_bits = windowBits, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = memLevel + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1), s.window = new common.Buf8(2 * s.w_size), s.head = new common.Buf16(s.hash_size), s.prev = new common.Buf16(s.w_size), s.lit_bufsize = 1 << memLevel + 6, s.pending_buf_size = 4 * s.lit_bufsize, s.pending_buf = new common.Buf8(s.pending_buf_size), s.d_buf = 1 * s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = level, s.strategy = strategy, s.method = method, deflateReset(strm);
}

configuration_table = [new Config(0, 0, 0, 0, function (s, flush) {
  var max_block_size = 65535;

  for (max_block_size > s.pending_buf_size - 5 && (max_block_size = s.pending_buf_size - 5);;) {
    if (s.lookahead <= 1) {
      if (fill_window(s), 0 === s.lookahead && flush === Z_NO_FLUSH) return BS_NEED_MORE;
      if (0 === s.lookahead) break;
    }

    s.strstart += s.lookahead, s.lookahead = 0;
    var max_start = s.block_start + max_block_size;
    if ((0 === s.strstart || s.strstart >= max_start) && (s.lookahead = s.strstart - max_start, s.strstart = max_start, flush_block_only(s, !1), 0 === s.strm.avail_out)) return BS_NEED_MORE;
    if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD && (flush_block_only(s, !1), 0 === s.strm.avail_out)) return BS_NEED_MORE;
  }

  return s.insert = 0, flush === Z_FINISH ? (flush_block_only(s, !0), 0 === s.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : (s.strstart > s.block_start && (flush_block_only(s, !1), s.strm.avail_out), BS_NEED_MORE);
}), new Config(4, 4, 8, 4, deflate_fast), new Config(4, 5, 16, 8, deflate_fast), new Config(4, 6, 32, 32, deflate_fast), new Config(4, 4, 16, 16, deflate_slow), new Config(8, 16, 32, 32, deflate_slow), new Config(8, 16, 128, 128, deflate_slow), new Config(8, 32, 128, 256, deflate_slow), new Config(32, 128, 258, 1024, deflate_slow), new Config(32, 258, 258, 4096, deflate_slow)];
var deflate_1 = {
  deflateInit: function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
  },
  deflateInit2: deflateInit2,
  deflateReset: deflateReset,
  deflateResetKeep: deflateResetKeep,
  deflateSetHeader: function deflateSetHeader(strm, head) {
    return strm && strm.state ? 2 !== strm.state.wrap ? Z_STREAM_ERROR : (strm.state.gzhead = head, Z_OK) : Z_STREAM_ERROR;
  },
  deflate: function deflate(strm, flush) {
    var old_flush, s, beg, val;
    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
    if (s = strm.state, !strm.output || !strm.input && 0 !== strm.avail_in || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, 0 === strm.avail_out ? Z_BUF_ERROR : Z_STREAM_ERROR);
    if (s.strm = strm, old_flush = s.last_flush, s.last_flush = flush, s.status === INIT_STATE) if (2 === s.wrap) strm.adler = 0, put_byte(s, 31), put_byte(s, 139), put_byte(s, 8), s.gzhead ? (put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (s.gzhead.extra ? 4 : 0) + (s.gzhead.name ? 8 : 0) + (s.gzhead.comment ? 16 : 0)), put_byte(s, 255 & s.gzhead.time), put_byte(s, s.gzhead.time >> 8 & 255), put_byte(s, s.gzhead.time >> 16 & 255), put_byte(s, s.gzhead.time >> 24 & 255), put_byte(s, 9 === s.level ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0), put_byte(s, 255 & s.gzhead.os), s.gzhead.extra && s.gzhead.extra.length && (put_byte(s, 255 & s.gzhead.extra.length), put_byte(s, s.gzhead.extra.length >> 8 & 255)), s.gzhead.hcrc && (strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0)), s.gzindex = 0, s.status = EXTRA_STATE) : (put_byte(s, 0), put_byte(s, 0), put_byte(s, 0), put_byte(s, 0), put_byte(s, 0), put_byte(s, 9 === s.level ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0), put_byte(s, OS_CODE), s.status = BUSY_STATE);else {
      var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
      header |= (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 0 : s.level < 6 ? 1 : 6 === s.level ? 2 : 3) << 6, 0 !== s.strstart && (header |= PRESET_DICT), header += 31 - header % 31, s.status = BUSY_STATE, putShortMSB(s, header), 0 !== s.strstart && (putShortMSB(s, strm.adler >>> 16), putShortMSB(s, 65535 & strm.adler)), strm.adler = 1;
    }
    if (s.status === EXTRA_STATE) if (s.gzhead.extra) {
      for (beg = s.pending; s.gzindex < (65535 & s.gzhead.extra.length) && (s.pending !== s.pending_buf_size || (s.gzhead.hcrc && s.pending > beg && (strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg)), flush_pending(strm), beg = s.pending, s.pending !== s.pending_buf_size));) {
        put_byte(s, 255 & s.gzhead.extra[s.gzindex]), s.gzindex++;
      }

      s.gzhead.hcrc && s.pending > beg && (strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg)), s.gzindex === s.gzhead.extra.length && (s.gzindex = 0, s.status = NAME_STATE);
    } else s.status = NAME_STATE;
    if (s.status === NAME_STATE) if (s.gzhead.name) {
      beg = s.pending;

      do {
        if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > beg && (strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg)), flush_pending(strm), beg = s.pending, s.pending === s.pending_buf_size)) {
          val = 1;
          break;
        }

        val = s.gzindex < s.gzhead.name.length ? 255 & s.gzhead.name.charCodeAt(s.gzindex++) : 0, put_byte(s, val);
      } while (0 !== val);

      s.gzhead.hcrc && s.pending > beg && (strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg)), 0 === val && (s.gzindex = 0, s.status = COMMENT_STATE);
    } else s.status = COMMENT_STATE;
    if (s.status === COMMENT_STATE) if (s.gzhead.comment) {
      beg = s.pending;

      do {
        if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > beg && (strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg)), flush_pending(strm), beg = s.pending, s.pending === s.pending_buf_size)) {
          val = 1;
          break;
        }

        val = s.gzindex < s.gzhead.comment.length ? 255 & s.gzhead.comment.charCodeAt(s.gzindex++) : 0, put_byte(s, val);
      } while (0 !== val);

      s.gzhead.hcrc && s.pending > beg && (strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg)), 0 === val && (s.status = HCRC_STATE);
    } else s.status = HCRC_STATE;

    if (s.status === HCRC_STATE && (s.gzhead.hcrc ? (s.pending + 2 > s.pending_buf_size && flush_pending(strm), s.pending + 2 <= s.pending_buf_size && (put_byte(s, 255 & strm.adler), put_byte(s, strm.adler >> 8 & 255), strm.adler = 0, s.status = BUSY_STATE)) : s.status = BUSY_STATE), 0 !== s.pending) {
      if (flush_pending(strm), 0 === strm.avail_out) return s.last_flush = -1, Z_OK;
    } else if (0 === strm.avail_in && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);

    if (s.status === FINISH_STATE && 0 !== strm.avail_in) return err(strm, Z_BUF_ERROR);

    if (0 !== strm.avail_in || 0 !== s.lookahead || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
      var bstate = s.strategy === Z_HUFFMAN_ONLY ? function (s, flush) {
        for (var bflush;;) {
          if (0 === s.lookahead && (fill_window(s), 0 === s.lookahead)) {
            if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
            break;
          }

          if (s.match_length = 0, bflush = trees._tr_tally(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++, bflush && (flush_block_only(s, !1), 0 === s.strm.avail_out)) return BS_NEED_MORE;
        }

        return s.insert = 0, flush === Z_FINISH ? (flush_block_only(s, !0), 0 === s.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : s.last_lit && (flush_block_only(s, !1), 0 === s.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
      }(s, flush) : s.strategy === Z_RLE ? function (s, flush) {
        for (var bflush, prev, scan, strend, _win = s.window;;) {
          if (s.lookahead <= MAX_MATCH$1) {
            if (fill_window(s), s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (0 === s.lookahead) break;
          }

          if (s.match_length = 0, s.lookahead >= MIN_MATCH$1 && s.strstart > 0 && (prev = _win[scan = s.strstart - 1]) === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
            strend = s.strstart + MAX_MATCH$1;

            do {} while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);

            s.match_length = MAX_MATCH$1 - (strend - scan), s.match_length > s.lookahead && (s.match_length = s.lookahead);
          }

          if (s.match_length >= MIN_MATCH$1 ? (bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH$1), s.lookahead -= s.match_length, s.strstart += s.match_length, s.match_length = 0) : (bflush = trees._tr_tally(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++), bflush && (flush_block_only(s, !1), 0 === s.strm.avail_out)) return BS_NEED_MORE;
        }

        return s.insert = 0, flush === Z_FINISH ? (flush_block_only(s, !0), 0 === s.strm.avail_out ? BS_FINISH_STARTED : BS_FINISH_DONE) : s.last_lit && (flush_block_only(s, !1), 0 === s.strm.avail_out) ? BS_NEED_MORE : BS_BLOCK_DONE;
      }(s, flush) : configuration_table[s.level].func(s, flush);
      if (bstate !== BS_FINISH_STARTED && bstate !== BS_FINISH_DONE || (s.status = FINISH_STATE), bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) return 0 === strm.avail_out && (s.last_flush = -1), Z_OK;
      if (bstate === BS_BLOCK_DONE && (flush === Z_PARTIAL_FLUSH ? trees._tr_align(s) : flush !== Z_BLOCK && (trees._tr_stored_block(s, 0, 0, !1), flush === Z_FULL_FLUSH && (zero$1(s.head), 0 === s.lookahead && (s.strstart = 0, s.block_start = 0, s.insert = 0))), flush_pending(strm), 0 === strm.avail_out)) return s.last_flush = -1, Z_OK;
    }

    return flush !== Z_FINISH ? Z_OK : s.wrap <= 0 ? Z_STREAM_END : (2 === s.wrap ? (put_byte(s, 255 & strm.adler), put_byte(s, strm.adler >> 8 & 255), put_byte(s, strm.adler >> 16 & 255), put_byte(s, strm.adler >> 24 & 255), put_byte(s, 255 & strm.total_in), put_byte(s, strm.total_in >> 8 & 255), put_byte(s, strm.total_in >> 16 & 255), put_byte(s, strm.total_in >> 24 & 255)) : (putShortMSB(s, strm.adler >>> 16), putShortMSB(s, 65535 & strm.adler)), flush_pending(strm), s.wrap > 0 && (s.wrap = -s.wrap), 0 !== s.pending ? Z_OK : Z_STREAM_END);
  },
  deflateEnd: function deflateEnd(strm) {
    var status;
    return strm && strm.state ? (status = strm.state.status) !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE ? err(strm, Z_STREAM_ERROR) : (strm.state = null, status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK) : Z_STREAM_ERROR;
  },
  deflateSetDictionary: function deflateSetDictionary(strm, dictionary) {
    var s,
        str,
        n,
        wrap,
        avail,
        next,
        input,
        tmpDict,
        dictLength = dictionary.length;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    if (2 === (wrap = (s = strm.state).wrap) || 1 === wrap && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;

    for (1 === wrap && (strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0)), s.wrap = 0, dictLength >= s.w_size && (0 === wrap && (zero$1(s.head), s.strstart = 0, s.block_start = 0, s.insert = 0), tmpDict = new common.Buf8(s.w_size), common.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0), dictionary = tmpDict, dictLength = s.w_size), avail = strm.avail_in, next = strm.next_in, input = strm.input, strm.avail_in = dictLength, strm.next_in = 0, strm.input = dictionary, fill_window(s); s.lookahead >= MIN_MATCH$1;) {
      str = s.strstart, n = s.lookahead - (MIN_MATCH$1 - 1);

      do {
        s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH$1 - 1]) & s.hash_mask, s.prev[str & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = str, str++;
      } while (--n);

      s.strstart = str, s.lookahead = MIN_MATCH$1 - 1, fill_window(s);
    }

    return s.strstart += s.lookahead, s.block_start = s.strstart, s.insert = s.lookahead, s.lookahead = 0, s.match_length = s.prev_length = MIN_MATCH$1 - 1, s.match_available = 0, strm.next_in = next, strm.input = input, strm.avail_in = avail, s.wrap = wrap, Z_OK;
  },
  deflateInfo: "pako deflate (from Nodeca project)"
},
    STR_APPLY_OK = !0,
    STR_APPLY_UIA_OK = !0;

try {
  String.fromCharCode.apply(null, [0]);
} catch (__) {
  STR_APPLY_OK = !1;
}

try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
  STR_APPLY_UIA_OK = !1;
}

for (var _utf8len = new common.Buf8(256), q = 0; q < 256; q++) {
  _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
}

_utf8len[254] = _utf8len[254] = 1;

function _buf2binstring(buf, len) {
  if (len < 65534 && (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK)) return String.fromCharCode.apply(null, common.shrinkBuf(buf, len));

  for (var result = "", i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }

  return result;
}

var strings = {
  string2buf: function string2buf(str) {
    var buf,
        c,
        c2,
        m_pos,
        i,
        str_len = str.length,
        buf_len = 0;

    for (m_pos = 0; m_pos < str_len; m_pos++) {
      55296 == (64512 & (c = str.charCodeAt(m_pos))) && m_pos + 1 < str_len && 56320 == (64512 & (c2 = str.charCodeAt(m_pos + 1))) && (c = 65536 + (c - 55296 << 10) + (c2 - 56320), m_pos++), buf_len += c < 128 ? 1 : c < 2048 ? 2 : c < 65536 ? 3 : 4;
    }

    for (buf = new common.Buf8(buf_len), i = 0, m_pos = 0; i < buf_len; m_pos++) {
      55296 == (64512 & (c = str.charCodeAt(m_pos))) && m_pos + 1 < str_len && 56320 == (64512 & (c2 = str.charCodeAt(m_pos + 1))) && (c = 65536 + (c - 55296 << 10) + (c2 - 56320), m_pos++), c < 128 ? buf[i++] = c : c < 2048 ? (buf[i++] = 192 | c >>> 6, buf[i++] = 128 | 63 & c) : c < 65536 ? (buf[i++] = 224 | c >>> 12, buf[i++] = 128 | c >>> 6 & 63, buf[i++] = 128 | 63 & c) : (buf[i++] = 240 | c >>> 18, buf[i++] = 128 | c >>> 12 & 63, buf[i++] = 128 | c >>> 6 & 63, buf[i++] = 128 | 63 & c);
    }

    return buf;
  },
  buf2binstring: function buf2binstring(buf) {
    return _buf2binstring(buf, buf.length);
  },
  binstring2buf: function binstring2buf(str) {
    for (var buf = new common.Buf8(str.length), i = 0, len = buf.length; i < len; i++) {
      buf[i] = str.charCodeAt(i);
    }

    return buf;
  },
  buf2string: function buf2string(buf, max) {
    var i,
        out,
        c,
        c_len,
        len = max || buf.length,
        utf16buf = new Array(2 * len);

    for (out = 0, i = 0; i < len;) {
      if ((c = buf[i++]) < 128) utf16buf[out++] = c;else if ((c_len = _utf8len[c]) > 4) utf16buf[out++] = 65533, i += c_len - 1;else {
        for (c &= 2 === c_len ? 31 : 3 === c_len ? 15 : 7; c_len > 1 && i < len;) {
          c = c << 6 | 63 & buf[i++], c_len--;
        }

        c_len > 1 ? utf16buf[out++] = 65533 : c < 65536 ? utf16buf[out++] = c : (c -= 65536, utf16buf[out++] = 55296 | c >> 10 & 1023, utf16buf[out++] = 56320 | 1023 & c);
      }
    }

    return _buf2binstring(utf16buf, out);
  },
  utf8border: function utf8border(buf, max) {
    var pos;

    for ((max = max || buf.length) > buf.length && (max = buf.length), pos = max - 1; pos >= 0 && 128 == (192 & buf[pos]);) {
      pos--;
    }

    return pos < 0 ? max : 0 === pos ? max : pos + _utf8len[buf[pos]] > max ? pos : max;
  }
};

var zstream = function zstream() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
},
    toString = Object.prototype.toString,
    Z_OK$1 = 0,
    Z_DEFAULT_COMPRESSION$1 = -1,
    Z_DEFAULT_STRATEGY$1 = 0,
    Z_DEFLATED$1 = 8;

function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION$1,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY$1,
    to: ""
  }, options || {});
  var opt = this.options;
  opt.raw && opt.windowBits > 0 ? opt.windowBits = -opt.windowBits : opt.gzip && opt.windowBits > 0 && opt.windowBits < 16 && (opt.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream(), this.strm.avail_out = 0;
  var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
  if (status !== Z_OK$1) throw new Error(messages[status]);

  if (opt.header && deflate_1.deflateSetHeader(this.strm, opt.header), opt.dictionary) {
    var dict;
    if (dict = "string" == typeof opt.dictionary ? strings.string2buf(opt.dictionary) : "[object ArrayBuffer]" === toString.call(opt.dictionary) ? new Uint8Array(opt.dictionary) : opt.dictionary, (status = deflate_1.deflateSetDictionary(this.strm, dict)) !== Z_OK$1) throw new Error(messages[status]);
    this._dict_set = !0;
  }
}

function deflate$1(input, options) {
  var deflator = new Deflate(options);
  if (deflator.push(input, !0), deflator.err) throw deflator.msg || messages[deflator.err];
  return deflator.result;
}

Deflate.prototype.push = function (data, mode) {
  var status,
      _mode,
      strm = this.strm,
      chunkSize = this.options.chunkSize;

  if (this.ended) return !1;
  _mode = mode === ~~mode ? mode : !0 === mode ? 4 : 0, "string" == typeof data ? strm.input = strings.string2buf(data) : "[object ArrayBuffer]" === toString.call(data) ? strm.input = new Uint8Array(data) : strm.input = data, strm.next_in = 0, strm.avail_in = strm.input.length;

  do {
    if (0 === strm.avail_out && (strm.output = new common.Buf8(chunkSize), strm.next_out = 0, strm.avail_out = chunkSize), 1 !== (status = deflate_1.deflate(strm, _mode)) && status !== Z_OK$1) return this.onEnd(status), this.ended = !0, !1;
    0 !== strm.avail_out && (0 !== strm.avail_in || 4 !== _mode && 2 !== _mode) || ("string" === this.options.to ? this.onData(strings.buf2binstring(common.shrinkBuf(strm.output, strm.next_out))) : this.onData(common.shrinkBuf(strm.output, strm.next_out)));
  } while ((strm.avail_in > 0 || 0 === strm.avail_out) && 1 !== status);

  return 4 === _mode ? (status = deflate_1.deflateEnd(this.strm), this.onEnd(status), this.ended = !0, status === Z_OK$1) : 2 !== _mode || (this.onEnd(Z_OK$1), strm.avail_out = 0, !0);
}, Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
}, Deflate.prototype.onEnd = function (status) {
  status === Z_OK$1 && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = status, this.msg = this.strm.msg;
};

var deflate_1$1 = {
  Deflate: Deflate,
  deflate: deflate$1,
  deflateRaw: function deflateRaw(input, options) {
    return (options = options || {}).raw = !0, deflate$1(input, options);
  },
  gzip: function gzip(input, options) {
    return (options = options || {}).gzip = !0, deflate$1(input, options);
  }
},
    inffast = function inffast(strm, start) {
  var state, _in, last, _out, beg, end, dmax, wsize, whave, wnext, s_window, hold, bits, lcode, dcode, lmask, dmask, here, op, len, dist, from, from_source, input, output;

  state = strm.state, _in = strm.next_in, input = strm.input, last = _in + (strm.avail_in - 5), _out = strm.next_out, output = strm.output, beg = _out - (start - strm.avail_out), end = _out + (strm.avail_out - 257), dmax = state.dmax, wsize = state.wsize, whave = state.whave, wnext = state.wnext, s_window = state.window, hold = state.hold, bits = state.bits, lcode = state.lencode, dcode = state.distcode, lmask = (1 << state.lenbits) - 1, dmask = (1 << state.distbits) - 1;

  top: do {
    bits < 15 && (hold += input[_in++] << bits, bits += 8, hold += input[_in++] << bits, bits += 8), here = lcode[hold & lmask];

    dolen: for (;;) {
      if (hold >>>= op = here >>> 24, bits -= op, 0 === (op = here >>> 16 & 255)) output[_out++] = 65535 & here;else {
        if (!(16 & op)) {
          if (0 == (64 & op)) {
            here = lcode[(65535 & here) + (hold & (1 << op) - 1)];
            continue dolen;
          }

          if (32 & op) {
            state.mode = 12;
            break top;
          }

          strm.msg = "invalid literal/length code", state.mode = 30;
          break top;
        }

        len = 65535 & here, (op &= 15) && (bits < op && (hold += input[_in++] << bits, bits += 8), len += hold & (1 << op) - 1, hold >>>= op, bits -= op), bits < 15 && (hold += input[_in++] << bits, bits += 8, hold += input[_in++] << bits, bits += 8), here = dcode[hold & dmask];

        dodist: for (;;) {
          if (hold >>>= op = here >>> 24, bits -= op, !(16 & (op = here >>> 16 & 255))) {
            if (0 == (64 & op)) {
              here = dcode[(65535 & here) + (hold & (1 << op) - 1)];
              continue dodist;
            }

            strm.msg = "invalid distance code", state.mode = 30;
            break top;
          }

          if (dist = 65535 & here, bits < (op &= 15) && (hold += input[_in++] << bits, (bits += 8) < op && (hold += input[_in++] << bits, bits += 8)), (dist += hold & (1 << op) - 1) > dmax) {
            strm.msg = "invalid distance too far back", state.mode = 30;
            break top;
          }

          if (hold >>>= op, bits -= op, dist > (op = _out - beg)) {
            if ((op = dist - op) > whave && state.sane) {
              strm.msg = "invalid distance too far back", state.mode = 30;
              break top;
            }

            if (from = 0, from_source = s_window, 0 === wnext) {
              if (from += wsize - op, op < len) {
                len -= op;

                do {
                  output[_out++] = s_window[from++];
                } while (--op);

                from = _out - dist, from_source = output;
              }
            } else if (wnext < op) {
              if (from += wsize + wnext - op, (op -= wnext) < len) {
                len -= op;

                do {
                  output[_out++] = s_window[from++];
                } while (--op);

                if (from = 0, wnext < len) {
                  len -= op = wnext;

                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);

                  from = _out - dist, from_source = output;
                }
              }
            } else if (from += wnext - op, op < len) {
              len -= op;

              do {
                output[_out++] = s_window[from++];
              } while (--op);

              from = _out - dist, from_source = output;
            }

            for (; len > 2;) {
              output[_out++] = from_source[from++], output[_out++] = from_source[from++], output[_out++] = from_source[from++], len -= 3;
            }

            len && (output[_out++] = from_source[from++], len > 1 && (output[_out++] = from_source[from++]));
          } else {
            from = _out - dist;

            do {
              output[_out++] = output[from++], output[_out++] = output[from++], output[_out++] = output[from++], len -= 3;
            } while (len > 2);

            len && (output[_out++] = output[from++], len > 1 && (output[_out++] = output[from++]));
          }

          break;
        }
      }
      break;
    }
  } while (_in < last && _out < end);

  _in -= len = bits >> 3, hold &= (1 << (bits -= len << 3)) - 1, strm.next_in = _in, strm.next_out = _out, strm.avail_in = _in < last ? last - _in + 5 : 5 - (_in - last), strm.avail_out = _out < end ? end - _out + 257 : 257 - (_out - end), state.hold = hold, state.bits = bits;
},
    lbase = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
    lext = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
    dbase = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
    dext = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64],
    inftrees = function inftrees(type, lens, lens_index, codes, table, table_index, work, opts) {
  var incr,
      fill,
      low,
      mask,
      next,
      end,
      here_bits,
      here_op,
      here_val,
      bits = opts.bits,
      len = 0,
      sym = 0,
      min = 0,
      max = 0,
      root = 0,
      curr = 0,
      drop = 0,
      left = 0,
      used = 0,
      huff = 0,
      base = null,
      base_index = 0,
      count = new common.Buf16(16),
      offs = new common.Buf16(16),
      extra = null,
      extra_index = 0;

  for (len = 0; len <= 15; len++) {
    count[len] = 0;
  }

  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  for (root = bits, max = 15; max >= 1 && 0 === count[max]; max--) {
    ;
  }

  if (root > max && (root = max), 0 === max) return table[table_index++] = 20971520, table[table_index++] = 20971520, opts.bits = 1, 0;

  for (min = 1; min < max && 0 === count[min]; min++) {
    ;
  }

  for (root < min && (root = min), left = 1, len = 1; len <= 15; len++) {
    if (left <<= 1, (left -= count[len]) < 0) return -1;
  }

  if (left > 0 && (0 === type || 1 !== max)) return -1;

  for (offs[1] = 0, len = 1; len < 15; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  for (sym = 0; sym < codes; sym++) {
    0 !== lens[lens_index + sym] && (work[offs[lens[lens_index + sym]]++] = sym);
  }

  if (0 === type ? (base = extra = work, end = 19) : 1 === type ? (base = lbase, base_index -= 257, extra = lext, extra_index -= 257, end = 256) : (base = dbase, extra = dext, end = -1), huff = 0, sym = 0, len = min, next = table_index, curr = root, drop = 0, low = -1, mask = (used = 1 << root) - 1, 1 === type && used > 852 || 2 === type && used > 592) return 1;

  for (;;) {
    here_bits = len - drop, work[sym] < end ? (here_op = 0, here_val = work[sym]) : work[sym] > end ? (here_op = extra[extra_index + work[sym]], here_val = base[base_index + work[sym]]) : (here_op = 96, here_val = 0), incr = 1 << len - drop, min = fill = 1 << curr;

    do {
      table[next + (huff >> drop) + (fill -= incr)] = here_bits << 24 | here_op << 16 | here_val | 0;
    } while (0 !== fill);

    for (incr = 1 << len - 1; huff & incr;) {
      incr >>= 1;
    }

    if (0 !== incr ? (huff &= incr - 1, huff += incr) : huff = 0, sym++, 0 == --count[len]) {
      if (len === max) break;
      len = lens[lens_index + work[sym]];
    }

    if (len > root && (huff & mask) !== low) {
      for (0 === drop && (drop = root), next += min, left = 1 << (curr = len - drop); curr + drop < max && !((left -= count[curr + drop]) <= 0);) {
        curr++, left <<= 1;
      }

      if (used += 1 << curr, 1 === type && used > 852 || 2 === type && used > 592) return 1;
      table[low = huff & mask] = root << 24 | curr << 16 | next - table_index | 0;
    }
  }

  return 0 !== huff && (table[next + huff] = len - drop << 24 | 64 << 16 | 0), opts.bits = root, 0;
},
    CODES$1 = 0,
    LENS$1 = 1,
    DISTS$1 = 2,
    Z_FINISH$2 = 4,
    Z_BLOCK$1 = 5,
    Z_TREES = 6,
    Z_OK$2 = 0,
    Z_STREAM_END$2 = 1,
    Z_NEED_DICT = 2,
    Z_STREAM_ERROR$1 = -2,
    Z_DATA_ERROR$1 = -3,
    Z_MEM_ERROR = -4,
    Z_BUF_ERROR$1 = -5,
    Z_DEFLATED$2 = 8,
    HEAD = 1,
    FLAGS = 2,
    TIME = 3,
    OS = 4,
    EXLEN = 5,
    EXTRA = 6,
    NAME = 7,
    COMMENT = 8,
    HCRC = 9,
    DICTID = 10,
    DICT = 11,
    TYPE$1 = 12,
    TYPEDO = 13,
    STORED = 14,
    COPY_ = 15,
    COPY = 16,
    TABLE = 17,
    LENLENS = 18,
    CODELENS = 19,
    LEN_ = 20,
    LEN = 21,
    LENEXT = 22,
    DIST = 23,
    DISTEXT = 24,
    MATCH = 25,
    LIT = 26,
    CHECK = 27,
    LENGTH = 28,
    DONE = 29,
    BAD$1 = 30,
    MEM = 31,
    SYNC = 32,
    ENOUGH_LENS$1 = 852,
    ENOUGH_DISTS$1 = 592,
    DEF_WBITS = 15;

function zswap32(q) {
  return (q >>> 24 & 255) + (q >>> 8 & 65280) + ((65280 & q) << 8) + ((255 & q) << 24);
}

function InflateState() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new common.Buf16(320), this.work = new common.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}

function inflateResetKeep(strm) {
  var state;
  return strm && strm.state ? (state = strm.state, strm.total_in = strm.total_out = state.total = 0, strm.msg = "", state.wrap && (strm.adler = 1 & state.wrap), state.mode = HEAD, state.last = 0, state.havedict = 0, state.dmax = 32768, state.head = null, state.hold = 0, state.bits = 0, state.lencode = state.lendyn = new common.Buf32(ENOUGH_LENS$1), state.distcode = state.distdyn = new common.Buf32(ENOUGH_DISTS$1), state.sane = 1, state.back = -1, Z_OK$2) : Z_STREAM_ERROR$1;
}

function inflateReset(strm) {
  var state;
  return strm && strm.state ? ((state = strm.state).wsize = 0, state.whave = 0, state.wnext = 0, inflateResetKeep(strm)) : Z_STREAM_ERROR$1;
}

function inflateReset2(strm, windowBits) {
  var wrap, state;
  return strm && strm.state ? (state = strm.state, windowBits < 0 ? (wrap = 0, windowBits = -windowBits) : (wrap = 1 + (windowBits >> 4), windowBits < 48 && (windowBits &= 15)), windowBits && (windowBits < 8 || windowBits > 15) ? Z_STREAM_ERROR$1 : (null !== state.window && state.wbits !== windowBits && (state.window = null), state.wrap = wrap, state.wbits = windowBits, inflateReset(strm))) : Z_STREAM_ERROR$1;
}

function inflateInit2(strm, windowBits) {
  var ret, state;
  return strm ? (state = new InflateState(), strm.state = state, state.window = null, (ret = inflateReset2(strm, windowBits)) !== Z_OK$2 && (strm.state = null), ret) : Z_STREAM_ERROR$1;
}

var lenfix,
    distfix,
    virgin = !0;

function fixedtables(state) {
  if (virgin) {
    var sym;

    for (lenfix = new common.Buf32(512), distfix = new common.Buf32(32), sym = 0; sym < 144;) {
      state.lens[sym++] = 8;
    }

    for (; sym < 256;) {
      state.lens[sym++] = 9;
    }

    for (; sym < 280;) {
      state.lens[sym++] = 7;
    }

    for (; sym < 288;) {
      state.lens[sym++] = 8;
    }

    for (inftrees(LENS$1, state.lens, 0, 288, lenfix, 0, state.work, {
      bits: 9
    }), sym = 0; sym < 32;) {
      state.lens[sym++] = 5;
    }

    inftrees(DISTS$1, state.lens, 0, 32, distfix, 0, state.work, {
      bits: 5
    }), virgin = !1;
  }

  state.lencode = lenfix, state.lenbits = 9, state.distcode = distfix, state.distbits = 5;
}

function updatewindow(strm, src, end, copy) {
  var dist,
      state = strm.state;
  return null === state.window && (state.wsize = 1 << state.wbits, state.wnext = 0, state.whave = 0, state.window = new common.Buf8(state.wsize)), copy >= state.wsize ? (common.arraySet(state.window, src, end - state.wsize, state.wsize, 0), state.wnext = 0, state.whave = state.wsize) : ((dist = state.wsize - state.wnext) > copy && (dist = copy), common.arraySet(state.window, src, end - copy, dist, state.wnext), (copy -= dist) ? (common.arraySet(state.window, src, end - copy, copy, 0), state.wnext = copy, state.whave = state.wsize) : (state.wnext += dist, state.wnext === state.wsize && (state.wnext = 0), state.whave < state.wsize && (state.whave += dist))), 0;
}

var inflate_1 = {
  inflateReset: inflateReset,
  inflateReset2: inflateReset2,
  inflateResetKeep: inflateResetKeep,
  inflateInit: function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
  },
  inflateInit2: inflateInit2,
  inflate: function inflate(strm, flush) {
    var state,
        input,
        output,
        next,
        put,
        have,
        left,
        hold,
        bits,
        _in,
        _out,
        copy,
        from,
        from_source,
        here_bits,
        here_op,
        here_val,
        last_bits,
        last_op,
        last_val,
        len,
        ret,
        opts,
        n,
        here = 0,
        hbuf = new common.Buf8(4),
        order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

    if (!strm || !strm.state || !strm.output || !strm.input && 0 !== strm.avail_in) return Z_STREAM_ERROR$1;
    (state = strm.state).mode === TYPE$1 && (state.mode = TYPEDO), put = strm.next_out, output = strm.output, left = strm.avail_out, next = strm.next_in, input = strm.input, have = strm.avail_in, hold = state.hold, bits = state.bits, _in = have, _out = left, ret = Z_OK$2;

    inf_leave: for (;;) {
      switch (state.mode) {
        case HEAD:
          if (0 === state.wrap) {
            state.mode = TYPEDO;
            break;
          }

          for (; bits < 16;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          if (2 & state.wrap && 35615 === hold) {
            state.check = 0, hbuf[0] = 255 & hold, hbuf[1] = hold >>> 8 & 255, state.check = crc32_1(state.check, hbuf, 2, 0), hold = 0, bits = 0, state.mode = FLAGS;
            break;
          }

          if (state.flags = 0, state.head && (state.head.done = !1), !(1 & state.wrap) || (((255 & hold) << 8) + (hold >> 8)) % 31) {
            strm.msg = "incorrect header check", state.mode = BAD$1;
            break;
          }

          if ((15 & hold) !== Z_DEFLATED$2) {
            strm.msg = "unknown compression method", state.mode = BAD$1;
            break;
          }

          if (bits -= 4, len = 8 + (15 & (hold >>>= 4)), 0 === state.wbits) state.wbits = len;else if (len > state.wbits) {
            strm.msg = "invalid window size", state.mode = BAD$1;
            break;
          }
          state.dmax = 1 << len, strm.adler = state.check = 1, state.mode = 512 & hold ? DICTID : TYPE$1, hold = 0, bits = 0;
          break;

        case FLAGS:
          for (; bits < 16;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          if (state.flags = hold, (255 & state.flags) !== Z_DEFLATED$2) {
            strm.msg = "unknown compression method", state.mode = BAD$1;
            break;
          }

          if (57344 & state.flags) {
            strm.msg = "unknown header flags set", state.mode = BAD$1;
            break;
          }

          state.head && (state.head.text = hold >> 8 & 1), 512 & state.flags && (hbuf[0] = 255 & hold, hbuf[1] = hold >>> 8 & 255, state.check = crc32_1(state.check, hbuf, 2, 0)), hold = 0, bits = 0, state.mode = TIME;

        case TIME:
          for (; bits < 32;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          state.head && (state.head.time = hold), 512 & state.flags && (hbuf[0] = 255 & hold, hbuf[1] = hold >>> 8 & 255, hbuf[2] = hold >>> 16 & 255, hbuf[3] = hold >>> 24 & 255, state.check = crc32_1(state.check, hbuf, 4, 0)), hold = 0, bits = 0, state.mode = OS;

        case OS:
          for (; bits < 16;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          state.head && (state.head.xflags = 255 & hold, state.head.os = hold >> 8), 512 & state.flags && (hbuf[0] = 255 & hold, hbuf[1] = hold >>> 8 & 255, state.check = crc32_1(state.check, hbuf, 2, 0)), hold = 0, bits = 0, state.mode = EXLEN;

        case EXLEN:
          if (1024 & state.flags) {
            for (; bits < 16;) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            state.length = hold, state.head && (state.head.extra_len = hold), 512 & state.flags && (hbuf[0] = 255 & hold, hbuf[1] = hold >>> 8 & 255, state.check = crc32_1(state.check, hbuf, 2, 0)), hold = 0, bits = 0;
          } else state.head && (state.head.extra = null);

          state.mode = EXTRA;

        case EXTRA:
          if (1024 & state.flags && ((copy = state.length) > have && (copy = have), copy && (state.head && (len = state.head.extra_len - state.length, state.head.extra || (state.head.extra = new Array(state.head.extra_len)), common.arraySet(state.head.extra, input, next, copy, len)), 512 & state.flags && (state.check = crc32_1(state.check, input, copy, next)), have -= copy, next += copy, state.length -= copy), state.length)) break inf_leave;
          state.length = 0, state.mode = NAME;

        case NAME:
          if (2048 & state.flags) {
            if (0 === have) break inf_leave;
            copy = 0;

            do {
              len = input[next + copy++], state.head && len && state.length < 65536 && (state.head.name += String.fromCharCode(len));
            } while (len && copy < have);

            if (512 & state.flags && (state.check = crc32_1(state.check, input, copy, next)), have -= copy, next += copy, len) break inf_leave;
          } else state.head && (state.head.name = null);

          state.length = 0, state.mode = COMMENT;

        case COMMENT:
          if (4096 & state.flags) {
            if (0 === have) break inf_leave;
            copy = 0;

            do {
              len = input[next + copy++], state.head && len && state.length < 65536 && (state.head.comment += String.fromCharCode(len));
            } while (len && copy < have);

            if (512 & state.flags && (state.check = crc32_1(state.check, input, copy, next)), have -= copy, next += copy, len) break inf_leave;
          } else state.head && (state.head.comment = null);

          state.mode = HCRC;

        case HCRC:
          if (512 & state.flags) {
            for (; bits < 16;) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            if (hold !== (65535 & state.check)) {
              strm.msg = "header crc mismatch", state.mode = BAD$1;
              break;
            }

            hold = 0, bits = 0;
          }

          state.head && (state.head.hcrc = state.flags >> 9 & 1, state.head.done = !0), strm.adler = state.check = 0, state.mode = TYPE$1;
          break;

        case DICTID:
          for (; bits < 32;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          strm.adler = state.check = zswap32(hold), hold = 0, bits = 0, state.mode = DICT;

        case DICT:
          if (0 === state.havedict) return strm.next_out = put, strm.avail_out = left, strm.next_in = next, strm.avail_in = have, state.hold = hold, state.bits = bits, Z_NEED_DICT;
          strm.adler = state.check = 1, state.mode = TYPE$1;

        case TYPE$1:
          if (flush === Z_BLOCK$1 || flush === Z_TREES) break inf_leave;

        case TYPEDO:
          if (state.last) {
            hold >>>= 7 & bits, bits -= 7 & bits, state.mode = CHECK;
            break;
          }

          for (; bits < 3;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          switch (state.last = 1 & hold, bits -= 1, 3 & (hold >>>= 1)) {
            case 0:
              state.mode = STORED;
              break;

            case 1:
              if (fixedtables(state), state.mode = LEN_, flush === Z_TREES) {
                hold >>>= 2, bits -= 2;
                break inf_leave;
              }

              break;

            case 2:
              state.mode = TABLE;
              break;

            case 3:
              strm.msg = "invalid block type", state.mode = BAD$1;
          }

          hold >>>= 2, bits -= 2;
          break;

        case STORED:
          for (hold >>>= 7 & bits, bits -= 7 & bits; bits < 32;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          if ((65535 & hold) != (hold >>> 16 ^ 65535)) {
            strm.msg = "invalid stored block lengths", state.mode = BAD$1;
            break;
          }

          if (state.length = 65535 & hold, hold = 0, bits = 0, state.mode = COPY_, flush === Z_TREES) break inf_leave;

        case COPY_:
          state.mode = COPY;

        case COPY:
          if (copy = state.length) {
            if (copy > have && (copy = have), copy > left && (copy = left), 0 === copy) break inf_leave;
            common.arraySet(output, input, next, copy, put), have -= copy, next += copy, left -= copy, put += copy, state.length -= copy;
            break;
          }

          state.mode = TYPE$1;
          break;

        case TABLE:
          for (; bits < 14;) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          if (state.nlen = 257 + (31 & hold), hold >>>= 5, bits -= 5, state.ndist = 1 + (31 & hold), hold >>>= 5, bits -= 5, state.ncode = 4 + (15 & hold), hold >>>= 4, bits -= 4, state.nlen > 286 || state.ndist > 30) {
            strm.msg = "too many length or distance symbols", state.mode = BAD$1;
            break;
          }

          state.have = 0, state.mode = LENLENS;

        case LENLENS:
          for (; state.have < state.ncode;) {
            for (; bits < 3;) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            state.lens[order[state.have++]] = 7 & hold, hold >>>= 3, bits -= 3;
          }

          for (; state.have < 19;) {
            state.lens[order[state.have++]] = 0;
          }

          if (state.lencode = state.lendyn, state.lenbits = 7, opts = {
            bits: state.lenbits
          }, ret = inftrees(CODES$1, state.lens, 0, 19, state.lencode, 0, state.work, opts), state.lenbits = opts.bits, ret) {
            strm.msg = "invalid code lengths set", state.mode = BAD$1;
            break;
          }

          state.have = 0, state.mode = CODELENS;

        case CODELENS:
          for (; state.have < state.nlen + state.ndist;) {
            for (; here_op = (here = state.lencode[hold & (1 << state.lenbits) - 1]) >>> 16 & 255, here_val = 65535 & here, !((here_bits = here >>> 24) <= bits);) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            if (here_val < 16) hold >>>= here_bits, bits -= here_bits, state.lens[state.have++] = here_val;else {
              if (16 === here_val) {
                for (n = here_bits + 2; bits < n;) {
                  if (0 === have) break inf_leave;
                  have--, hold += input[next++] << bits, bits += 8;
                }

                if (hold >>>= here_bits, bits -= here_bits, 0 === state.have) {
                  strm.msg = "invalid bit length repeat", state.mode = BAD$1;
                  break;
                }

                len = state.lens[state.have - 1], copy = 3 + (3 & hold), hold >>>= 2, bits -= 2;
              } else if (17 === here_val) {
                for (n = here_bits + 3; bits < n;) {
                  if (0 === have) break inf_leave;
                  have--, hold += input[next++] << bits, bits += 8;
                }

                bits -= here_bits, len = 0, copy = 3 + (7 & (hold >>>= here_bits)), hold >>>= 3, bits -= 3;
              } else {
                for (n = here_bits + 7; bits < n;) {
                  if (0 === have) break inf_leave;
                  have--, hold += input[next++] << bits, bits += 8;
                }

                bits -= here_bits, len = 0, copy = 11 + (127 & (hold >>>= here_bits)), hold >>>= 7, bits -= 7;
              }

              if (state.have + copy > state.nlen + state.ndist) {
                strm.msg = "invalid bit length repeat", state.mode = BAD$1;
                break;
              }

              for (; copy--;) {
                state.lens[state.have++] = len;
              }
            }
          }

          if (state.mode === BAD$1) break;

          if (0 === state.lens[256]) {
            strm.msg = "invalid code -- missing end-of-block", state.mode = BAD$1;
            break;
          }

          if (state.lenbits = 9, opts = {
            bits: state.lenbits
          }, ret = inftrees(LENS$1, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts), state.lenbits = opts.bits, ret) {
            strm.msg = "invalid literal/lengths set", state.mode = BAD$1;
            break;
          }

          if (state.distbits = 6, state.distcode = state.distdyn, opts = {
            bits: state.distbits
          }, ret = inftrees(DISTS$1, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts), state.distbits = opts.bits, ret) {
            strm.msg = "invalid distances set", state.mode = BAD$1;
            break;
          }

          if (state.mode = LEN_, flush === Z_TREES) break inf_leave;

        case LEN_:
          state.mode = LEN;

        case LEN:
          if (have >= 6 && left >= 258) {
            strm.next_out = put, strm.avail_out = left, strm.next_in = next, strm.avail_in = have, state.hold = hold, state.bits = bits, inffast(strm, _out), put = strm.next_out, output = strm.output, left = strm.avail_out, next = strm.next_in, input = strm.input, have = strm.avail_in, hold = state.hold, bits = state.bits, state.mode === TYPE$1 && (state.back = -1);
            break;
          }

          for (state.back = 0; here_op = (here = state.lencode[hold & (1 << state.lenbits) - 1]) >>> 16 & 255, here_val = 65535 & here, !((here_bits = here >>> 24) <= bits);) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          if (here_op && 0 == (240 & here_op)) {
            for (last_bits = here_bits, last_op = here_op, last_val = here_val; here_op = (here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)]) >>> 16 & 255, here_val = 65535 & here, !(last_bits + (here_bits = here >>> 24) <= bits);) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            hold >>>= last_bits, bits -= last_bits, state.back += last_bits;
          }

          if (hold >>>= here_bits, bits -= here_bits, state.back += here_bits, state.length = here_val, 0 === here_op) {
            state.mode = LIT;
            break;
          }

          if (32 & here_op) {
            state.back = -1, state.mode = TYPE$1;
            break;
          }

          if (64 & here_op) {
            strm.msg = "invalid literal/length code", state.mode = BAD$1;
            break;
          }

          state.extra = 15 & here_op, state.mode = LENEXT;

        case LENEXT:
          if (state.extra) {
            for (n = state.extra; bits < n;) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            state.length += hold & (1 << state.extra) - 1, hold >>>= state.extra, bits -= state.extra, state.back += state.extra;
          }

          state.was = state.length, state.mode = DIST;

        case DIST:
          for (; here_op = (here = state.distcode[hold & (1 << state.distbits) - 1]) >>> 16 & 255, here_val = 65535 & here, !((here_bits = here >>> 24) <= bits);) {
            if (0 === have) break inf_leave;
            have--, hold += input[next++] << bits, bits += 8;
          }

          if (0 == (240 & here_op)) {
            for (last_bits = here_bits, last_op = here_op, last_val = here_val; here_op = (here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)]) >>> 16 & 255, here_val = 65535 & here, !(last_bits + (here_bits = here >>> 24) <= bits);) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            hold >>>= last_bits, bits -= last_bits, state.back += last_bits;
          }

          if (hold >>>= here_bits, bits -= here_bits, state.back += here_bits, 64 & here_op) {
            strm.msg = "invalid distance code", state.mode = BAD$1;
            break;
          }

          state.offset = here_val, state.extra = 15 & here_op, state.mode = DISTEXT;

        case DISTEXT:
          if (state.extra) {
            for (n = state.extra; bits < n;) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            state.offset += hold & (1 << state.extra) - 1, hold >>>= state.extra, bits -= state.extra, state.back += state.extra;
          }

          if (state.offset > state.dmax) {
            strm.msg = "invalid distance too far back", state.mode = BAD$1;
            break;
          }

          state.mode = MATCH;

        case MATCH:
          if (0 === left) break inf_leave;

          if (copy = _out - left, state.offset > copy) {
            if ((copy = state.offset - copy) > state.whave && state.sane) {
              strm.msg = "invalid distance too far back", state.mode = BAD$1;
              break;
            }

            copy > state.wnext ? (copy -= state.wnext, from = state.wsize - copy) : from = state.wnext - copy, copy > state.length && (copy = state.length), from_source = state.window;
          } else from_source = output, from = put - state.offset, copy = state.length;

          copy > left && (copy = left), left -= copy, state.length -= copy;

          do {
            output[put++] = from_source[from++];
          } while (--copy);

          0 === state.length && (state.mode = LEN);
          break;

        case LIT:
          if (0 === left) break inf_leave;
          output[put++] = state.length, left--, state.mode = LEN;
          break;

        case CHECK:
          if (state.wrap) {
            for (; bits < 32;) {
              if (0 === have) break inf_leave;
              have--, hold |= input[next++] << bits, bits += 8;
            }

            if (_out -= left, strm.total_out += _out, state.total += _out, _out && (strm.adler = state.check = state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out)), _out = left, (state.flags ? hold : zswap32(hold)) !== state.check) {
              strm.msg = "incorrect data check", state.mode = BAD$1;
              break;
            }

            hold = 0, bits = 0;
          }

          state.mode = LENGTH;

        case LENGTH:
          if (state.wrap && state.flags) {
            for (; bits < 32;) {
              if (0 === have) break inf_leave;
              have--, hold += input[next++] << bits, bits += 8;
            }

            if (hold !== (4294967295 & state.total)) {
              strm.msg = "incorrect length check", state.mode = BAD$1;
              break;
            }

            hold = 0, bits = 0;
          }

          state.mode = DONE;

        case DONE:
          ret = Z_STREAM_END$2;
          break inf_leave;

        case BAD$1:
          ret = Z_DATA_ERROR$1;
          break inf_leave;

        case MEM:
          return Z_MEM_ERROR;

        case SYNC:
        default:
          return Z_STREAM_ERROR$1;
      }
    }

    return strm.next_out = put, strm.avail_out = left, strm.next_in = next, strm.avail_in = have, state.hold = hold, state.bits = bits, (state.wsize || _out !== strm.avail_out && state.mode < BAD$1 && (state.mode < CHECK || flush !== Z_FINISH$2)) && updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out), _in -= strm.avail_in, _out -= strm.avail_out, strm.total_in += _in, strm.total_out += _out, state.total += _out, state.wrap && _out && (strm.adler = state.check = state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out)), strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE$1 ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0), (0 === _in && 0 === _out || flush === Z_FINISH$2) && ret === Z_OK$2 && (ret = Z_BUF_ERROR$1), ret;
  },
  inflateEnd: function inflateEnd(strm) {
    if (!strm || !strm.state) return Z_STREAM_ERROR$1;
    var state = strm.state;
    return state.window && (state.window = null), strm.state = null, Z_OK$2;
  },
  inflateGetHeader: function inflateGetHeader(strm, head) {
    var state;
    return strm && strm.state ? 0 == (2 & (state = strm.state).wrap) ? Z_STREAM_ERROR$1 : (state.head = head, head.done = !1, Z_OK$2) : Z_STREAM_ERROR$1;
  },
  inflateSetDictionary: function inflateSetDictionary(strm, dictionary) {
    var state,
        dictLength = dictionary.length;
    return strm && strm.state ? 0 !== (state = strm.state).wrap && state.mode !== DICT ? Z_STREAM_ERROR$1 : state.mode === DICT && adler32_1(1, dictionary, dictLength, 0) !== state.check ? Z_DATA_ERROR$1 : updatewindow(strm, dictionary, dictLength, dictLength) ? (state.mode = MEM, Z_MEM_ERROR) : (state.havedict = 1, Z_OK$2) : Z_STREAM_ERROR$1;
  },
  inflateInfo: "pako inflate (from Nodeca project)"
},
    constants = {
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_BUF_ERROR: -5,
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  Z_BINARY: 0,
  Z_TEXT: 1,
  Z_UNKNOWN: 2,
  Z_DEFLATED: 8
};

var gzheader = function gzheader() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
},
    toString$1 = Object.prototype.toString;

function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);
  this.options = common.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ""
  }, options || {});
  var opt = this.options;
  opt.raw && opt.windowBits >= 0 && opt.windowBits < 16 && (opt.windowBits = -opt.windowBits, 0 === opt.windowBits && (opt.windowBits = -15)), !(opt.windowBits >= 0 && opt.windowBits < 16) || options && options.windowBits || (opt.windowBits += 32), opt.windowBits > 15 && opt.windowBits < 48 && 0 == (15 & opt.windowBits) && (opt.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new zstream(), this.strm.avail_out = 0;
  var status = inflate_1.inflateInit2(this.strm, opt.windowBits);
  if (status !== constants.Z_OK) throw new Error(messages[status]);
  if (this.header = new gzheader(), inflate_1.inflateGetHeader(this.strm, this.header), opt.dictionary && ("string" == typeof opt.dictionary ? opt.dictionary = strings.string2buf(opt.dictionary) : "[object ArrayBuffer]" === toString$1.call(opt.dictionary) && (opt.dictionary = new Uint8Array(opt.dictionary)), opt.raw && (status = inflate_1.inflateSetDictionary(this.strm, opt.dictionary)) !== constants.Z_OK)) throw new Error(messages[status]);
}

function inflate$1(input, options) {
  var inflator = new Inflate(options);
  if (inflator.push(input, !0), inflator.err) throw inflator.msg || messages[inflator.err];
  return inflator.result;
}

Inflate.prototype.push = function (data, mode) {
  var status,
      _mode,
      next_out_utf8,
      tail,
      utf8str,
      strm = this.strm,
      chunkSize = this.options.chunkSize,
      dictionary = this.options.dictionary,
      allowBufError = !1;

  if (this.ended) return !1;
  _mode = mode === ~~mode ? mode : !0 === mode ? constants.Z_FINISH : constants.Z_NO_FLUSH, "string" == typeof data ? strm.input = strings.binstring2buf(data) : "[object ArrayBuffer]" === toString$1.call(data) ? strm.input = new Uint8Array(data) : strm.input = data, strm.next_in = 0, strm.avail_in = strm.input.length;

  do {
    if (0 === strm.avail_out && (strm.output = new common.Buf8(chunkSize), strm.next_out = 0, strm.avail_out = chunkSize), (status = inflate_1.inflate(strm, constants.Z_NO_FLUSH)) === constants.Z_NEED_DICT && dictionary && (status = inflate_1.inflateSetDictionary(this.strm, dictionary)), status === constants.Z_BUF_ERROR && !0 === allowBufError && (status = constants.Z_OK, allowBufError = !1), status !== constants.Z_STREAM_END && status !== constants.Z_OK) return this.onEnd(status), this.ended = !0, !1;
    strm.next_out && (0 !== strm.avail_out && status !== constants.Z_STREAM_END && (0 !== strm.avail_in || _mode !== constants.Z_FINISH && _mode !== constants.Z_SYNC_FLUSH) || ("string" === this.options.to ? (next_out_utf8 = strings.utf8border(strm.output, strm.next_out), tail = strm.next_out - next_out_utf8, utf8str = strings.buf2string(strm.output, next_out_utf8), strm.next_out = tail, strm.avail_out = chunkSize - tail, tail && common.arraySet(strm.output, strm.output, next_out_utf8, tail, 0), this.onData(utf8str)) : this.onData(common.shrinkBuf(strm.output, strm.next_out)))), 0 === strm.avail_in && 0 === strm.avail_out && (allowBufError = !0);
  } while ((strm.avail_in > 0 || 0 === strm.avail_out) && status !== constants.Z_STREAM_END);

  return status === constants.Z_STREAM_END && (_mode = constants.Z_FINISH), _mode === constants.Z_FINISH ? (status = inflate_1.inflateEnd(this.strm), this.onEnd(status), this.ended = !0, status === constants.Z_OK) : _mode !== constants.Z_SYNC_FLUSH || (this.onEnd(constants.Z_OK), strm.avail_out = 0, !0);
}, Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
}, Inflate.prototype.onEnd = function (status) {
  status === constants.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = common.flattenChunks(this.chunks)), this.chunks = [], this.err = status, this.msg = this.strm.msg;
};
var inflate_1$1 = {
  Inflate: Inflate,
  inflate: inflate$1,
  inflateRaw: function inflateRaw(input, options) {
    return (options = options || {}).raw = !0, inflate$1(input, options);
  },
  ungzip: inflate$1
},
    pako = {};
(0, common.assign)(pako, deflate_1$1, inflate_1$1, constants);
var pako_1 = pako,
    max = 1e13;

var Int10 = /*#__PURE__*/function () {
  function Int10(value) {
    _classCallCheck(this, Int10);

    this.buf = [+value || 0];
  }

  _createClass(Int10, [{
    key: "mulAdd",
    value: function mulAdd(m, c) {
      var i,
          t,
          b = this.buf,
          l = b.length;

      for (i = 0; i < l; ++i) {
        (t = b[i] * m + c) < max ? c = 0 : t -= (c = 0 | t / max) * max, b[i] = t;
      }

      c > 0 && (b[i] = c);
    }
  }, {
    key: "sub",
    value: function sub(c) {
      var i,
          t,
          b = this.buf,
          l = b.length;

      for (i = 0; i < l; ++i) {
        (t = b[i] - c) < 0 ? (t += max, c = 1) : c = 0, b[i] = t;
      }

      for (; 0 === b[b.length - 1];) {
        b.pop();
      }
    }
  }, {
    key: "toString",
    value: function toString(base) {
      if (10 != (base || 10)) throw "only base 10 is supported";

      for (var b = this.buf, s = b[b.length - 1].toString(), i = b.length - 2; i >= 0; --i) {
        s += (max + b[i]).toString().substring(1);
      }

      return s;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      for (var b = this.buf, v = 0, i = b.length - 1; i >= 0; --i) {
        v = v * max + b[i];
      }

      return v;
    }
  }, {
    key: "simplify",
    value: function simplify() {
      var b = this.buf;
      return 1 == b.length ? b[0] : this;
    }
  }]);

  return Int10;
}();

var UNSUPPORTED_ALGORITHM = 'Unsupported algorithm name specified! Supported algorithms: "HS256", "HS384", "HS512", "RS256", "RS384", "RS512" and "none".',
    ILLEGAL_ARGUMENT = "Illegal argument specified!",
    CRYPTO_NOT_FOUND = "Could not find 'crypto'.",
    PAKO_NOT_FOUND = "Could not find 'pako'.";

function generateErrorMessage(value, callee) {
  var argumentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "argument";
  var defaultType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "string";
  var message = "Invalid argument passed to ".concat(callee, ".");
  return typeof value !== defaultType ? message += " Expected type '".concat(defaultType, "', received '").concat(typeof value, "'.") : value ? "argument" !== argumentName && (message += " Provided ".concat(argumentName, " is invalid.")) : message += " Provided ".concat(argumentName, " is empty."), message;
}

function hex2AB(hex) {
  if (!hex) throw new Error(ILLEGAL_ARGUMENT);
  var match = hex.match(/[0-9A-F]{2}/gi);
  if (!match) throw new Error(ILLEGAL_ARGUMENT);
  return new Uint8Array(match.map(function (i) {
    return parseInt(i, 16);
  }));
}

var ellipsis = "…",
    reTimeS = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/,
    reTimeL = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;

function stringCut(str, len) {
  return str.length > len && (str = str.substring(0, len) + ellipsis), str;
}

var Stream = /*#__PURE__*/function () {
  function Stream(enc) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Stream);

    this.hexDigits = "0123456789ABCDEF", enc instanceof Stream ? (this.enc = enc.enc, this.pos = enc.pos) : (this.enc = enc, this.pos = pos);
  }

  _createClass(Stream, [{
    key: "get",
    value: function get(pos) {
      if (void 0 === pos && (pos = this.pos++), pos >= this.enc.length) throw "Requesting byte offset " + pos + " on a stream of length " + this.enc.length;
      return "string" == typeof this.enc ? this.enc.charCodeAt(pos) : this.enc[pos];
    }
  }, {
    key: "hexByte",
    value: function hexByte(b) {
      return this.hexDigits.charAt(b >> 4 & 15) + this.hexDigits.charAt(15 & b);
    }
  }, {
    key: "hexDump",
    value: function hexDump(start, end, raw) {
      for (var s = "", i = start; i < end; ++i) {
        if (s += this.hexByte(this.get(i)), !0 !== raw) switch (15 & i) {
          case 7:
            s += "  ";
            break;

          case 15:
            s += "\n";
            break;

          default:
            s += " ";
        }
      }

      return s;
    }
  }, {
    key: "isASCII",
    value: function isASCII(start, end) {
      for (var i = start; i < end; ++i) {
        var c = this.get(i);
        if (c < 32 || c > 176) return !1;
      }

      return !0;
    }
  }, {
    key: "parseStringISO",
    value: function parseStringISO(start, end) {
      for (var s = "", i = start; i < end; ++i) {
        s += String.fromCharCode(this.get(i));
      }

      return s;
    }
  }, {
    key: "parseStringUTF",
    value: function parseStringUTF(start, end) {
      for (var s = "", i = start; i < end;) {
        var c = this.get(i++);
        s += c < 128 ? String.fromCharCode(c) : c > 191 && c < 224 ? String.fromCharCode((31 & c) << 6 | 63 & this.get(i++)) : String.fromCharCode((15 & c) << 12 | (63 & this.get(i++)) << 6 | 63 & this.get(i++));
      }

      return s;
    }
  }, {
    key: "parseStringBMP",
    value: function parseStringBMP(start, end) {
      for (var hi, lo, str = "", i = start; i < end;) {
        hi = this.get(i++), lo = this.get(i++), str += String.fromCharCode(hi << 8 | lo);
      }

      return str;
    }
  }, {
    key: "parseTime",
    value: function parseTime(start, end, shortYear) {
      var s = this.parseStringISO(start, end),
          m = (shortYear ? reTimeS : reTimeL).exec(s);
      if (!m) return "Unrecognized time: " + s;

      if (shortYear) {
        var y = +m[1] < 70 ? 2e3 : 1900;
        m[1] = y + "";
      }

      return s = m[1] + "-" + m[2] + "-" + m[3] + " " + m[4], m[5] && (s += ":" + m[5], m[6] && (s += ":" + m[6], m[7] && (s += "." + m[7]))), m[8] && (s += " UTC", "Z" != m[8] && (s += m[8], m[9] && (s += ":" + m[9]))), s;
    }
  }, {
    key: "parseInteger",
    value: function parseInteger(start, end) {
      for (var len, v = this.get(start), neg = v > 127, pad = neg ? 255 : 0, s = ""; v == pad && ++start < end;) {
        v = this.get(start);
      }

      if (0 === (len = end - start)) return neg ? -1 : 0;

      if (len > 4) {
        var t = +v;

        for (len <<= 3; 0 == (128 & (t ^ pad));) {
          t <<= 1, --len;
        }

        s = "(" + len + " bit)\n";
      }

      neg && (v -= 256);
      var n = new Int10(v);

      for (var i = start + 1; i < end; ++i) {
        n.mulAdd(256, this.get(i));
      }

      return s + n.toString();
    }
  }, {
    key: "parseBitString",
    value: function parseBitString(start, end, maxLength) {
      for (var unusedBit = this.get(start), intro = "(" + ((end - start - 1 << 3) - unusedBit) + " bit)\n", s = "", i = start + 1; i < end; ++i) {
        for (var b = this.get(i), skip = i == end - 1 ? unusedBit : 0, j = 7; j >= skip; --j) {
          s += b >> j & 1 ? "1" : "0";
        }

        if (s.length > maxLength) return intro + stringCut(s, maxLength);
      }

      return intro + s;
    }
  }, {
    key: "parseOctetString",
    value: function parseOctetString(start, end, maxLength) {
      if (this.isASCII(start, end)) return stringCut(this.parseStringISO(start, end), maxLength);
      var len = end - start,
          s = "(" + len + " byte)\n";
      len > (maxLength /= 2) && (end = start + maxLength);

      for (var i = start; i < end; ++i) {
        s += this.hexByte(this.get(i));
      }

      return len > maxLength && (s += ellipsis), s;
    }
  }, {
    key: "parseOID",
    value: function parseOID(start, end, maxLength) {
      for (var s = "", n = new Int10(), bits = 0, i = start; i < end; ++i) {
        var v = this.get(i);

        if (n.mulAdd(128, 127 & v), bits += 7, !(128 & v)) {
          if ("" === s) {
            if ((n = n.simplify()) instanceof Int10) n.sub(80), s = "2." + n.toString();else {
              var m = n < 80 ? n < 40 ? 0 : 1 : 2;
              s = m + "." + (n - 40 * m);
            }
          } else s += "." + n.toString();
          if (s.length > maxLength) return stringCut(s, maxLength);
          n = new Int10(), bits = 0;
        }
      }

      return bits > 0 && (s += ".incomplete"), s;
    }
  }]);

  return Stream;
}();

var ASN1 = /*#__PURE__*/function () {
  function ASN1(stream, header, length, tag, sub) {
    _classCallCheck(this, ASN1);

    if (!(tag instanceof ASN1Tag)) throw "Invalid tag value.";
    this.stream = stream, this.header = header, this.length = length, this.tag = tag, this.sub = sub;
  }

  _createClass(ASN1, [{
    key: "typeName",
    value: function typeName() {
      switch (this.tag.tagClass) {
        case 0:
          switch (this.tag.tagNumber) {
            case 0:
              return "EOC";

            case 1:
              return "BOOLEAN";

            case 2:
              return "INTEGER";

            case 3:
              return "BIT_STRING";

            case 4:
              return "OCTET_STRING";

            case 5:
              return "NULL";

            case 6:
              return "OBJECT_IDENTIFIER";

            case 7:
              return "ObjectDescriptor";

            case 8:
              return "EXTERNAL";

            case 9:
              return "REAL";

            case 10:
              return "ENUMERATED";

            case 11:
              return "EMBEDDED_PDV";

            case 12:
              return "UTF8String";

            case 16:
              return "SEQUENCE";

            case 17:
              return "SET";

            case 18:
              return "NumericString";

            case 19:
              return "PrintableString";

            case 20:
              return "TeletexString";

            case 21:
              return "VideotexString";

            case 22:
              return "IA5String";

            case 23:
              return "UTCTime";

            case 24:
              return "GeneralizedTime";

            case 25:
              return "GraphicString";

            case 26:
              return "VisibleString";

            case 27:
              return "GeneralString";

            case 28:
              return "UniversalString";

            case 30:
              return "BMPString";
          }

          return "Universal_" + this.tag.tagNumber.toString();

        case 1:
          return "Application_" + this.tag.tagNumber.toString();

        case 2:
          return "[" + this.tag.tagNumber.toString() + "]";

        case 3:
          return "Private_" + this.tag.tagNumber.toString();
      }
    }
  }, {
    key: "content",
    value: function content(maxLength) {
      if (void 0 === this.tag) return null;
      void 0 === maxLength && (maxLength = 1 / 0);
      var content = this.posContent(),
          len = Math.abs(this.length);
      if (!this.tag.isUniversal()) return null !== this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(content, content + len, maxLength);

      switch (this.tag.tagNumber) {
        case 1:
          return 0 === this.stream.get(content) ? "false" : "true";

        case 2:
          return this.stream.parseInteger(content, content + len);

        case 3:
          return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseBitString(content, content + len, maxLength);

        case 4:
          return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(content, content + len, maxLength);

        case 6:
          return this.stream.parseOID(content, content + len, maxLength);

        case 16:
        case 17:
          return null !== this.sub ? "(" + this.sub.length + " elem)" : "(no elem)";

        case 12:
          return stringCut(this.stream.parseStringUTF(content, content + len), maxLength);

        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 26:
          return stringCut(this.stream.parseStringISO(content, content + len), maxLength);

        case 30:
          return stringCut(this.stream.parseStringBMP(content, content + len), maxLength);

        case 23:
        case 24:
          return this.stream.parseTime(content, content + len, 23 == this.tag.tagNumber);
      }

      return null;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + (null === this.sub ? "null" : this.sub.length) + "]";
    }
  }, {
    key: "posStart",
    value: function posStart() {
      return this.stream.pos;
    }
  }, {
    key: "posContent",
    value: function posContent() {
      return this.stream.pos + this.header;
    }
  }, {
    key: "posEnd",
    value: function posEnd() {
      return this.stream.pos + this.header + Math.abs(this.length);
    }
  }, {
    key: "toHexString",
    value: function toHexString(root) {
      return this.stream.hexDump(this.posStart(), this.posEnd(), !0);
    }
  }, {
    key: "getHex",
    value: function getHex() {
      return this.stream.hexDump(this.posContent(), this.posEnd(), !0);
    }
  }, {
    key: "getAB",
    value: function getAB() {
      var clean = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      return clean ? function cleanZeros(b) {
        return 0 === b[0] ? cleanZeros(b.slice(1)) : b;
      }(hex2AB(this.getHex())) : hex2AB(this.getHex());
    }
  }], [{
    key: "decodeLength",
    value: function decodeLength(stream) {
      var buf = stream.get();
      var len = 127 & buf;
      if (len == buf) return len;
      if (len > 6) throw "Length over 48 bits not supported at position " + (stream.pos - 1);
      if (0 === len) return null;
      buf = 0;

      for (var i = 0; i < len; ++i) {
        buf = 256 * buf + stream.get();
      }

      return buf;
    }
  }, {
    key: "decode",
    value: function decode(stream) {
      stream instanceof Stream || (stream = new Stream(stream, 0));
      var streamStart = new Stream(stream),
          tag = new ASN1Tag(stream);
      var len = ASN1.decodeLength(stream),
          sub = null;

      var start = stream.pos,
          header = start - streamStart.pos,
          getSub = function getSub() {
        if (sub = [], null !== len) {
          for (var end = start + len; stream.pos < end;) {
            sub[sub.length] = ASN1.decode(stream);
          }

          if (stream.pos != end) throw "Content size is not correct for container starting at offset " + start;
        } else try {
          for (;;) {
            var s = ASN1.decode(stream);
            if (s.tag.isEOC()) break;
            sub[sub.length] = s;
          }

          len = start - stream.pos;
        } catch (e) {
          throw "Exception while decoding undefined length content: " + e;
        }
      };

      if (tag.tagConstructed) getSub();else if (tag.isUniversal() && (3 == tag.tagNumber || 4 == tag.tagNumber)) try {
        if (3 == tag.tagNumber && 0 != stream.get()) throw "BIT STRINGs with unused bits cannot encapsulate.";
        getSub();

        for (var i = 0; i < sub.length; ++i) {
          if (sub[i].tag.isEOC()) throw "EOC is not supposed to be actual content.";
        }
      } catch (e) {
        sub = null;
      }

      if (null === sub) {
        if (null === len) throw "We can't skip over an invalid tag with undefined length at offset " + start;
        stream.pos = start + Math.abs(len);
      }

      return new ASN1(streamStart, header, len, tag, sub);
    }
  }]);

  return ASN1;
}();

var ASN1Tag = /*#__PURE__*/function () {
  function ASN1Tag(stream) {
    _classCallCheck(this, ASN1Tag);

    var buf = stream.get();

    if (this.tagClass = buf >> 6, this.tagConstructed = 0 != (32 & buf), this.tagNumber = 31 & buf, 31 == this.tagNumber) {
      var n = new Int10();

      do {
        buf = stream.get(), n.mulAdd(128, 127 & buf);
      } while (128 & buf);

      this.tagNumber = n.simplify();
    }
  }

  _createClass(ASN1Tag, [{
    key: "isUniversal",
    value: function isUniversal() {
      return 0 === this.tagClass;
    }
  }, {
    key: "isEOC",
    value: function isEOC() {
      return 0 === this.tagClass && 0 === this.tagNumber;
    }
  }]);

  return ASN1Tag;
}();

var webCrypto = "object" == typeof window && (window.crypto || window.msCrypto),
    webCryptoSubtle = webCrypto && (webCrypto.subtle || webCrypto.webkitSubtle || webCrypto.Subtle);

var JwtSplit = /*#__PURE__*/function () {
  function JwtSplit(str) {
    var callee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "JwtSplit";

    _classCallCheck(this, JwtSplit);

    if ("string" != typeof str) throw new Error(generateErrorMessage(str, callee, "JWT string"));
    var jwtArr = str.split(".");
    if (3 !== jwtArr.length) throw new Error(generateErrorMessage(str, callee, "JWT string"));

    var _jwtArr = _slicedToArray(jwtArr, 3),
        header = _jwtArr[0],
        payload = _jwtArr[1],
        signature = _jwtArr[2];

    this.header = header, this.payload = payload, this.signature = signature;
  }

  _createClass(JwtSplit, [{
    key: "toString",
    value: function toString() {
      return this.header + "." + this.payload + "." + this.signature;
    }
  }]);

  return JwtSplit;
}();

var JwtDecode = /*#__PURE__*/function () {
  function JwtDecode(str) {
    var callee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "JwtDecode";

    _classCallCheck(this, JwtDecode);

    if (this.header = {}, this.payload = {}, this.signature = "", "string" != typeof str) throw new Error(generateErrorMessage(str, callee, "JWT string"));
    var jwtObj = jwtSplit(str, callee);
    jwtObj && (this.header = jwtObj.header ? s2J(bu2s(jwtObj.header)) : {}, this.payload = jwtObj.payload ? isGzip(this.header) ? s2J(zbu2s(jwtObj.payload)) : s2J(bu2s(jwtObj.payload)) : {}, this.signature = jwtObj.signature || "");
  }

  _createClass(JwtDecode, [{
    key: "toString",
    value: function toString() {
      return s2bu(J2s(this.header)) + "." + (isGzip(this.header) ? s2zbu(J2s(this.payload)) : s2bu(J2s(this.payload))) + "." + this.signature;
    }
  }]);

  return JwtDecode;
}();

function tryPromise(fn) {
  try {
    return Promise.resolve(fn());
  } catch (e) {
    return Promise.reject(e);
  }
}

function s2J(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    throw new Error(e.message);
  }
}

function J2s(obj) {
  try {
    return JSON.stringify(obj);
  } catch (e) {
    throw new Error(e.message);
  }
}

function b2s(str) {
  try {
    if ("object" == typeof window && "function" == typeof window.atob) return window.atob(str);
    if ("undefined" != typeof Buffer) return Buffer.from(str, "base64").toString("binary");
    throw new Error(ILLEGAL_ARGUMENT);
  } catch (e) {
    throw new Error(e);
  }
}

function b2bu(str) {
  if ("string" != typeof str || str.length % 4 != 0) throw new Error(ILLEGAL_ARGUMENT);
  return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

function bu2b(str) {
  if ("string" != typeof str || str.length % 4 == 1) throw new Error(ILLEGAL_ARGUMENT);

  for (; str.length % 4 != 0;) {
    str += "=";
  }

  return str.replace(/\-/g, "+").replace(/_/g, "/");
}

function bu2s(str) {
  return b2s(bu2b(str));
}

function isGzip(header) {
  return "object" == typeof header && "string" == typeof header.zip && "GZIP" === header.zip.toUpperCase();
}

function jwtDecode(str) {
  var callee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "jwtDecode";
  return new JwtDecode(str, callee);
}

function jwtSplit(str) {
  var callee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "jwtSplit";
  return new JwtSplit(str, callee);
}

var splitJwt = jwtSplit;

function s2b(str) {
  try {
    if ("object" == typeof window && "function" == typeof window.atob) return window.btoa(str);
    if ("undefined" != typeof Buffer) return Buffer.from(str).toString("base64");
    throw new Error(ILLEGAL_ARGUMENT);
  } catch (e) {
    throw new Error(e);
  }
}

function s2bu(str) {
  return b2bu(s2b(str));
}

function s2zbu(str) {
  return s2bu(zip(str));
}

function unzip(str) {
  if ("string" != typeof str) throw new Error(ILLEGAL_ARGUMENT);
  if (pako_1 && pako_1.inflate) return pako_1.inflate(str, {
    raw: !1,
    from: "string",
    to: "string"
  });
  throw new Error(PAKO_NOT_FOUND);
}

function zbu2s(str) {
  return unzip(bu2s(str));
}

function zip(str) {
  if ("string" != typeof str) throw new Error(ILLEGAL_ARGUMENT);
  if (pako_1 && pako_1.deflate) return pako_1.deflate(str, {
    raw: !1,
    from: "string",
    to: "string"
  });
  throw new Error(PAKO_NOT_FOUND);
}

function s2AB(str) {
  var buff = new Uint8Array(str.length);

  for (var i = 0; i < str.length; i++) {
    buff[i] = str.charCodeAt(i);
  }

  return buff;
}

function AB2s(buff) {
  return buff instanceof ArrayBuffer && (buff = new Uint8Array(buff)), String.fromCharCode.apply(String, Array.from(buff));
}

function createHmac(_x, _x2) {
  return _createHmac.apply(this, arguments);
}

function _createHmac() {
  _createHmac = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(name, secret) {
    var keyData, crypto;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!webCryptoSubtle) {
              _context7.next = 5;
              break;
            }

            keyData = s2AB(secret);
            _context7.next = 4;
            return webCryptoSubtle.importKey("raw", keyData, {
              name: "HMAC",
              hash: {
                name: name
              }
            }, !0, ["sign"]).then(function (key) {
              return {
                update: function () {
                  var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(thing) {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return webCryptoSubtle.sign("HMAC", key, s2AB(thing));

                          case 2:
                            return _context6.abrupt("return", _context6.sent);

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  function update(_x27) {
                    return _update.apply(this, arguments);
                  }

                  return update;
                }()
              };
            });

          case 4:
            return _context7.abrupt("return", _context7.sent);

          case 5:
            _context7.next = 7;
            return import("crypto");

          case 7:
            crypto = _context7.sent;
            return _context7.abrupt("return", crypto && crypto.createHmac ? Promise.resolve(crypto.createHmac(name.replace("SHA-", "sha"), secret)) : Promise.reject(webCrypto));

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _createHmac.apply(this, arguments);
}

function algHSsign(bits) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(thing, secret) {
      var hmac;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return createHmac("SHA-" + bits, secret);

            case 2:
              hmac = _context.sent;
              _context.t0 = Promise;

              if (!webCryptoSubtle) {
                _context.next = 17;
                break;
              }

              _context.t2 = s2bu;
              _context.t3 = AB2s;
              _context.t4 = hmac;

              if (!_context.t4) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return hmac.update(thing);

            case 11:
              _context.t4 = _context.sent;

            case 12:
              _context.t5 = _context.t4;
              _context.t6 = (0, _context.t3)(_context.t5);
              _context.t1 = (0, _context.t2)(_context.t6);
              _context.next = 18;
              break;

            case 17:
              _context.t1 = b2bu(hmac && hmac.update(thing).digest("base64"));

            case 18:
              _context.t7 = _context.t1;
              return _context.abrupt("return", _context.t0.resolve.call(_context.t0, _context.t7));

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
}

function algHSverify(bits) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(thing, signature, secret) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return algHSsign(bits)(thing, secret);

            case 2:
              _context2.t0 = _context2.sent;
              _context2.t1 = signature;
              return _context2.abrupt("return", _context2.t0 === _context2.t1);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x5, _x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function s2pem(secret) {
  if ("string" != typeof secret) throw new Error(ILLEGAL_ARGUMENT);
  var type = "public";
  var lines = secret.split("\n"),
      ignoreLinesPriv = ["-BEGIN RSA PRIVATE KEY-", "-END RSA PRIVATE KEY-"],
      ignoreLinesPub = ["-BEGIN RSA PUBLIC KEY-", "-BEGIN PUBLIC KEY-", "-END PUBLIC KEY-", "-END RSA PUBLIC KEY-"],
      body = lines.map(function (line) {
    return line.trim();
  }).filter(function (line) {
    return line.length && function (line) {
      return ignoreLinesPriv.some(function (ign) {
        return line.toUpperCase().indexOf(ign) > -1;
      }) ? (type = "private", !1) : !ignoreLinesPub.some(function (ign) {
        return line.toUpperCase().indexOf(ign) > -1;
      });
    }(line);
  }).join("");
  if (body.length) return {
    body: s2AB(b2s(bu2b(body))),
    type: type
  };
  throw new Error(ILLEGAL_ARGUMENT);
}

var Asn1Tag = function Asn1Tag(stream) {
  _classCallCheck(this, Asn1Tag);

  this.tagClass = 0, this.tagConstructed = !1, this.tagNumber = 0;
  var buf = stream.read();
  this.tagClass = buf >> 6, this.tagConstructed = 0 != (32 & buf), this.tagNumber = 31 & buf;
};

function pem2asn1(buff) {
  if (!buff) throw new Error(ILLEGAL_ARGUMENT);
  buff instanceof ArrayBuffer && (buff = new Uint8Array(buff));
  var asn1 = ASN1.decode(buff),
      res = {};
  if (3 === asn1.sub.length && (asn1 = asn1.sub[2].sub[0]), 9 === asn1.sub.length ? (res.modulus = asn1.sub[1].getAB(), res.publicExponent = parseInt(asn1.sub[2].getHex(), 16), res.privateExponent = asn1.sub[3].getAB(), res.prime1 = asn1.sub[4].getAB(), res.prime2 = asn1.sub[5].getAB(), res.exponent1 = asn1.sub[6].getAB(), res.exponent2 = asn1.sub[7].getAB(), res.coefficient = asn1.sub[8].getAB()) : 2 === asn1.sub.length && (asn1 = asn1.sub[1].sub[0], res.modulus = asn1.sub[0].getAB(), res.publicExponent = parseInt(asn1.sub[1].getHex(), 16)), res.bits = 8 * (res.modulus.length - 1) + Math.ceil(Math.log(res.modulus[0] + 1) / Math.log(2)), !res.bits) throw new Error(ILLEGAL_ARGUMENT);
  return res;
}

function asn12jwk(asn1, type, extra) {
  if (!asn1) throw new Error(ILLEGAL_ARGUMENT);
  if ("private" === (type = "string" == typeof type && type.toLowerCase() || ["public", "private"][asn1.privateExponent ? 1 : 0]) && !asn1.privateExponent) throw new Error(ILLEGAL_ARGUMENT);
  var v = asn1.publicExponent;
  var expSize = Math.ceil(Math.log(v) / Math.log(256)),
      exp = new Uint8Array(expSize).map(function (el) {
    return el = v % 256, v = Math.floor(v / 256), el;
  }).reverse();
  var jwk = Object.assign({
    kty: "RSA"
  }, extra, {
    n: s2bu(AB2s(asn1.modulus)),
    e: s2bu(AB2s(exp))
  });
  return "private" === type && Object.assign(jwk, {
    d: s2bu(AB2s(asn1.privateExponent)),
    p: s2bu(AB2s(asn1.prime1)),
    q: s2bu(AB2s(asn1.prime2)),
    dp: s2bu(AB2s(asn1.exponent1)),
    dq: s2bu(AB2s(asn1.exponent2)),
    qi: s2bu(AB2s(asn1.coefficient))
  }), jwk;
}

function pem2jwk(secret, type, extra) {
  return tryPromise(function () {
    return asn12jwk(pem2asn1(s2pem(secret).body), type, extra);
  });
}

function createSign(_x8) {
  return _createSign.apply(this, arguments);
}

function _createSign() {
  _createSign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(name) {
    var crypto;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!webCryptoSubtle) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return", {
              update: function update(thing) {
                return {
                  sign: function () {
                    var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(secret, encoding) {
                      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              _context10.next = 2;
                              return pem2jwk(secret, "private", {
                                key_ops: ["sign"],
                                alg: name.replace("SHA-", "RS")
                              }).then( /*#__PURE__*/function () {
                                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(keyData) {
                                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                                    while (1) {
                                      switch (_context9.prev = _context9.next) {
                                        case 0:
                                          _context9.next = 2;
                                          return webCryptoSubtle.importKey("jwk", keyData, {
                                            name: "RSASSA-PKCS1-v1_5",
                                            hash: {
                                              name: name
                                            }
                                          }, !0, ["sign"]).then( /*#__PURE__*/function () {
                                            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(key) {
                                              return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                                                while (1) {
                                                  switch (_context8.prev = _context8.next) {
                                                    case 0:
                                                      _context8.next = 2;
                                                      return webCryptoSubtle.sign({
                                                        name: "RSASSA-PKCS1-v1_5",
                                                        hash: {
                                                          name: name
                                                        }
                                                      }, key, s2AB(thing)).then(AB2s).then(s2b);

                                                    case 2:
                                                      return _context8.abrupt("return", _context8.sent);

                                                    case 3:
                                                    case "end":
                                                      return _context8.stop();
                                                  }
                                                }
                                              }, _callee8);
                                            }));

                                            return function (_x31) {
                                              return _ref7.apply(this, arguments);
                                            };
                                          }());

                                        case 2:
                                          return _context9.abrupt("return", _context9.sent);

                                        case 3:
                                        case "end":
                                          return _context9.stop();
                                      }
                                    }
                                  }, _callee9);
                                }));

                                return function (_x30) {
                                  return _ref6.apply(this, arguments);
                                };
                              }());

                            case 2:
                              return _context10.abrupt("return", _context10.sent);

                            case 3:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10);
                    }));

                    function sign(_x28, _x29) {
                      return _sign.apply(this, arguments);
                    }

                    return sign;
                  }()
                };
              }
            });

          case 2:
            _context11.next = 4;
            return import("crypto");

          case 4:
            crypto = _context11.sent;

            if (!(crypto && crypto.createSign)) {
              _context11.next = 7;
              break;
            }

            return _context11.abrupt("return", crypto.createSign(name.replace("SHA-", "RSA-SHA")));

          case 7:
            throw new Error(CRYPTO_NOT_FOUND);

          case 8:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _createSign.apply(this, arguments);
}

function algRSsign(bits) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(thing, privateKey) {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return createSign("SHA-" + bits);

            case 3:
              res = _context3.sent;
              _context3.t0 = b2bu;
              _context3.next = 7;
              return res.update(thing).sign(privateKey, "base64");

            case 7:
              _context3.t1 = _context3.sent;
              return _context3.abrupt("return", (0, _context3.t0)(_context3.t1));

            case 11:
              _context3.prev = 11;
              _context3.t2 = _context3["catch"](0);
              return _context3.abrupt("return", Promise.reject(_context3.t2));

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));

    return function (_x9, _x10) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function createVerify(_x11) {
  return _createVerify.apply(this, arguments);
}

function _createVerify() {
  _createVerify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(name) {
    var crypto;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (!webCryptoSubtle) {
              _context15.next = 2;
              break;
            }

            return _context15.abrupt("return", {
              update: function update(thing) {
                return {
                  verify: function () {
                    var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(secret, signature, encoding) {
                      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                        while (1) {
                          switch (_context14.prev = _context14.next) {
                            case 0:
                              _context14.next = 2;
                              return pem2jwk(secret, "public", {
                                key_ops: ["verify"],
                                alg: name.replace("SHA-", "RS")
                              }).then( /*#__PURE__*/function () {
                                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref8) {
                                  var kty, n, e;
                                  return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                                    while (1) {
                                      switch (_context13.prev = _context13.next) {
                                        case 0:
                                          kty = _ref8.kty, n = _ref8.n, e = _ref8.e;
                                          _context13.next = 3;
                                          return webCryptoSubtle.importKey("jwk", {
                                            kty: kty,
                                            n: n,
                                            e: e
                                          }, {
                                            name: "RSASSA-PKCS1-v1_5",
                                            hash: {
                                              name: name
                                            }
                                          }, !1, ["verify"]).then( /*#__PURE__*/function () {
                                            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(key) {
                                              return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                                                while (1) {
                                                  switch (_context12.prev = _context12.next) {
                                                    case 0:
                                                      _context12.next = 2;
                                                      return webCryptoSubtle.verify("RSASSA-PKCS1-v1_5", key, s2AB(bu2s(signature)), s2AB(thing));

                                                    case 2:
                                                      return _context12.abrupt("return", _context12.sent);

                                                    case 3:
                                                    case "end":
                                                      return _context12.stop();
                                                  }
                                                }
                                              }, _callee12);
                                            }));

                                            return function (_x36) {
                                              return _ref10.apply(this, arguments);
                                            };
                                          }());

                                        case 3:
                                          return _context13.abrupt("return", _context13.sent);

                                        case 4:
                                        case "end":
                                          return _context13.stop();
                                      }
                                    }
                                  }, _callee13);
                                }));

                                return function (_x35) {
                                  return _ref9.apply(this, arguments);
                                };
                              }());

                            case 2:
                              return _context14.abrupt("return", _context14.sent);

                            case 3:
                            case "end":
                              return _context14.stop();
                          }
                        }
                      }, _callee14);
                    }));

                    function verify(_x32, _x33, _x34) {
                      return _verify.apply(this, arguments);
                    }

                    return verify;
                  }()
                };
              }
            });

          case 2:
            _context15.next = 4;
            return import("crypto");

          case 4:
            crypto = _context15.sent;

            if (!(crypto && crypto.createVerify)) {
              _context15.next = 7;
              break;
            }

            return _context15.abrupt("return", crypto.createVerify(name.replace("SHA-", "RSA-SHA")));

          case 7:
            throw new Error(CRYPTO_NOT_FOUND);

          case 8:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _createVerify.apply(this, arguments);
}

function algRSverify(bits) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(thing, signature, publicKey) {
      var rsaVerify;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              signature = bu2b(signature);
              _context4.next = 4;
              return createVerify("SHA-" + bits);

            case 4:
              rsaVerify = _context4.sent;
              _context4.next = 7;
              return rsaVerify.update(thing).verify(publicKey, signature, "base64");

            case 7:
              return _context4.abrupt("return", _context4.sent);

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", Promise.reject(_context4.t0));

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 10]]);
    }));

    return function (_x12, _x13, _x14) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function algVerify(_x15, _x16, _x17, _x18) {
  return _algVerify.apply(this, arguments);
}

function _algVerify() {
  _algVerify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(algorithm, thing, signature, secret) {
    var algo, type, bits;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            if (!("string" != typeof algorithm || algorithm.length < 4)) {
              _context16.next = 2;
              break;
            }

            throw new Error(UNSUPPORTED_ALGORITHM);

          case 2:
            algo = algorithm.toLowerCase();

            if (!("none" === algo)) {
              _context16.next = 5;
              break;
            }

            return _context16.abrupt("return", "" === signature);

          case 5:
            type = algo.slice(0, 2), bits = parseInt(algo.slice(2));

            if (!(isNaN(bits) || [256, 384, 512].indexOf(bits) < 0)) {
              _context16.next = 8;
              break;
            }

            throw new Error(UNSUPPORTED_ALGORITHM);

          case 8:
            _context16.t0 = type;
            _context16.next = _context16.t0 === "rs" ? 11 : _context16.t0 === "hs" ? 14 : 17;
            break;

          case 11:
            _context16.next = 13;
            return algRSverify(bits)(thing, signature, secret);

          case 13:
            return _context16.abrupt("return", _context16.sent);

          case 14:
            _context16.next = 16;
            return algHSverify(bits)(thing, signature, secret);

          case 16:
            return _context16.abrupt("return", _context16.sent);

          case 17:
            throw new Error(UNSUPPORTED_ALGORITHM);

          case 18:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _algVerify.apply(this, arguments);
}

function algSign(_x19, _x20, _x21) {
  return _algSign.apply(this, arguments);
}

function _algSign() {
  _algSign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(algorithm, thing, secret) {
    var algo, type, bits;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            if (!("string" != typeof algorithm || algorithm.length < 4)) {
              _context17.next = 2;
              break;
            }

            throw new Error(UNSUPPORTED_ALGORITHM);

          case 2:
            algo = algorithm.toLowerCase();

            if (!("none" === algo)) {
              _context17.next = 5;
              break;
            }

            return _context17.abrupt("return", "");

          case 5:
            type = algo.slice(0, 2), bits = parseInt(algo.slice(2));

            if (!(isNaN(bits) || [256, 384, 512].indexOf(bits) < 0)) {
              _context17.next = 8;
              break;
            }

            throw new Error(UNSUPPORTED_ALGORITHM);

          case 8:
            _context17.t0 = type;
            _context17.next = _context17.t0 === "rs" ? 11 : _context17.t0 === "hs" ? 14 : 17;
            break;

          case 11:
            _context17.next = 13;
            return algRSsign(bits)(thing, secret);

          case 13:
            return _context17.abrupt("return", _context17.sent);

          case 14:
            _context17.next = 16;
            return algHSsign(bits)(thing, secret);

          case 16:
            return _context17.abrupt("return", _context17.sent);

          case 17:
            throw new Error(UNSUPPORTED_ALGORITHM);

          case 18:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _algSign.apply(this, arguments);
}

function jwtVerify(_x22, _x23) {
  return _jwtVerify.apply(this, arguments);
}

function _jwtVerify() {
  _jwtVerify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(jwtStr, secret) {
    var jwt, header, thing;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            jwt = jwtSplit(jwtStr, "jwtVerify"), header = s2J(bu2s(jwt.header)), thing = jwt.header + "." + jwt.payload;
            return _context18.abrupt("return", tryPromise(function () {
              return algVerify(header.alg, thing, jwt.signature, secret);
            }));

          case 2:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
  return _jwtVerify.apply(this, arguments);
}

var verifyJwt = jwtVerify;

function jwtSign(jwtStr, secret) {
  var jwt = jwtSplit(jwtStr, "jwtSign"),
      header = s2J(bu2s(jwt.header)),
      thing = jwt.header + "." + jwt.payload;
  return tryPromise( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return algSign(header.alg, thing, secret);

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })));
}

var signJwt = jwtSign;

function jwtResign(_x24, _x25, _x26) {
  return _jwtResign.apply(this, arguments);
}

function _jwtResign() {
  _jwtResign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(jwtStr, secret, alg) {
    var jwt;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            jwt = jwtDecode(jwtStr, "jwtResign");
            alg && (jwt.header.alg = alg);
            _context19.next = 4;
            return jwtSign(jwt.toString(), secret);

          case 4:
            jwt.signature = _context19.sent;
            return _context19.abrupt("return", jwt.toString());

          case 6:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _jwtResign.apply(this, arguments);
}

var resignJwt = jwtResign;

function cryptoType() {
  return _cryptoType.apply(this, arguments);
}

function _cryptoType() {
  _cryptoType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    var crypto;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return import("crypto");

          case 2:
            crypto = _context20.sent;
            return _context20.abrupt("return", crypto ? crypto.type || "crypto-node" : "undefined");

          case 4:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _cryptoType.apply(this, arguments);
}

export { AB2s, Asn1Tag, J2s, JwtDecode, JwtSplit, algHSsign, algHSverify, algRSsign, algRSverify, algSign, algVerify, asn12jwk, b2bu, b2s, bu2b, bu2s, createHmac, createSign, createVerify, cryptoType, isGzip, jwtDecode, jwtResign, jwtSign, jwtSplit, jwtVerify, pem2asn1, pem2jwk, resignJwt, s2AB, s2J, s2b, s2bu, s2pem, s2zbu, signJwt, splitJwt, tryPromise, unzip, verifyJwt, webCrypto, webCryptoSubtle, zbu2s, zip };